// IE 2026 09 24 / ODOO-… (заказ Игоря: объяснение элементов по Alt) · U6: КАРТА ОБЪЯСНЕНИЙ ОБЛАСТИ «ГРАФИКИ И КАРТЫ»
// (handoff-files/ui-help-2026-09-24/spec-charts-maps.json, 203 элемента: line/legend/bubble/map/graph/flow/player/treemap/gantt).
// Компоненты: AttrChart.vue (chart.line.*), ChartLegendPanel.vue (chart.legend.*, общая для line/bubble), AttrBubbleChart.vue (chart.bubble.*),
// AttrGeoMap.vue (chart.map.*), AttrGraph.vue (chart.graph.*), AttrAntFlow.vue (chart.flow.*), AntPlayer.vue (chart.player.*),
// AttrTreeMap.vue (chart.treemap.*), AttrGanttMoves.vue (chart.gantt.*). Тексты и состояния — из спецификации (help.en/uk/ru, states),
// выверены по коду коммита fe001 03244134b (24.09); расхождения со спекой и находки — README-U6.md рядом с волной.
// Способы подключения (см. src/utils/uiHelp.js и README ядра):
//   1 — v-uiHelp в шаблоне (кнопки, чекбоксы, вкладки окон легенд, строки TreeMap/Ганта, точки/связи карты);
//   2 — строки в СУЩЕСТВУЮЩУЮ подсказку (AttrButton.tooltip — быстрые настройки qs.*; карточка Ганта — chart.gantt.item/stockBar);
//   imperative uiHelp.bind(el, {...}) — ячейки, созданные в JS (ChartLegendPanel.gridFormatItem);
//   __altTipAt(x, y) (altTooltip.js, контракт cellChartAlt.js) — динамический хост canvas/wijmo (карта: территория/точка/связь по
//   hoverKey/hoverPoint/hoverLink; граф: узел/ребро/область по mapHoverEl.kind; поток: колонка по hoverEl.kind).
// Накат 25.09 (исполнитель U6): у 68 ключей, где текст объясняет, как ЧИТАТЬ элемент (цвета, размеры, обозначения, пустые состояния), поле click → how —
// ядро подписывает строку «How to use» («Як користуватися» / «Как пользоваться»), а не «Click»; тексты (ключи перевода) не менялись.
import { t, tn } from '@/i18n'

// IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): текст клика по области графика для новых сочетаний — расшифровка во вкладке Breakdown окна легенды (v.drill 2) и / или
// без плашки у точки (v.tipOff): из предложений (каждое — свой ключ перевода); прежние сочетания — прежние тексты целиком (chart.line.plot)
function chartPlotClick6(v = {}, ctx = {}) {
    const values = ctx.state === 'values'
    const parts = [
        v.tipOff ? t('Move along the dates — a vertical line at the nearest date and the date at the axis; there is no plate at the point: the values of all series at that date are in the Legend tab of the legend window; the series keep their look.')
            : values ? t('Move along the dates — a vertical line and a plate with the values of all series at the nearest date; the series keep their look.')
            : t('Hover a line / bar — the other series fade (a single series stays as it is), its value and date appear at the axes.'),
        (v.tipOff || values) ? t('Hover a row of the legend window — the other series fade.') : '',
        v.drill === 2 ? t('Click a point or a bar — the legend window opens at that date, its Breakdown tab shows what the value consists of by the dimensions of the source (a command to split the series). Alt+click — leave the legend window as it is.')
            : v.drill ? t('Click a point or a bar — its breakdown form opens (what the value consists of by the dimensions of the source, a command to split the series); an open legend window moves to that date. Alt+click — the legend window instead of the form (Legend position = Popup).')
            : t('Click a point — the legend window (Legend position = Popup) opens or shows the values of that date; Alt+click skips this.'),
        t('Drag along the dates (or Shift+click) — select a period.'),
    ]
    return parts.filter(Boolean).join(' ')
}

const charts = {
    // ---- line (37) ----
    'chart.line.legendBtn': (v = {}, ctx = {}) => ({
        // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): v.drill — у графика включена форма расшифровки (AttrChart: vars кнопки легенды): простой клик по точке открывает форму, окно — Alt+клик
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): v.drill 2 — расшифровка во вкладке Breakdown окна (клик по кусочку открывает окно на ней)
        title: t('Legend window'),
        what: v.drill === 2 ? t('Opens or closes the chart’s own legend window: the Breakdown tab — what the clicked point or bar consists of, the Legend tab — measures with their series, checkboxes and values by date.')
            : t('Opens or closes the chart’s own legend window: measures with their series, checkboxes and values by date.'),
        why: t('To read exact values, hide series and pick series for the filter without cluttering the plot.'),
        click: v.drill === 2 ? t('Click — open / close the window. A click on a point or a bar of the chart also opens it — with the breakdown of that piece in the Breakdown tab.')
            : v.drill ? t('Click — open / close the window. Alt+click on a point of the chart also opens it (a plain click opens the breakdown form of the point).') : t('Click — open / close the window. A click on a point of the chart also opens it.'),
        affects: t('Only this chart. The window closes together with the widget and hides on tabs it does not belong to.'),
        stored: t('Remembered for this widget while it is open (memory); not saved.'),
        setting: "viewParams.<chart>.legend-position = Popup; fe.ux.chartLegendAutoOpen; fe.ux.legendFollowsOwner",
        states: { "on": t('The legend window is open'), "off": t('The legend window is closed') },
    }),
    // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): вкладки окна легенды графика [Breakdown | Legend] (ChartLegendPanel на AttrTabPanel, вкладки из props)
    'chart.line.legend.tabBreakdown': (v = {}, ctx = {}) => ({
        title: t('Breakdown tab'),
        what: t('What the value of the last clicked point or bar consists of by the dimensions of the data source: the first values and «Others», with a command to split the series in this chart.'),
        why: t('To see which products, subjects or countries make up a point — right in the legend window.'),
        click: t('Click — switch the tab. Click a point or a bar of the chart — its breakdown appears here.'),
        stored: t('The chosen tab is remembered on this chart until the page is reloaded; nothing is saved.'),
        setting: "fe.ux.chartDrillTab; fe.ux.chartDrill; viewParams.<chart>.click-drill / drill-dims / drill-top",
        states: { "breakdown": t('Tab Breakdown'), "legend": t('Tab Legend') },
    }),
    'chart.line.legend.tabLegend': (v = {}, ctx = {}) => ({
        title: t('Legend tab'),
        what: t('The legend itself: measures with their series, checkboxes and values by date; the date follows the cursor and the clicked point.'),
        click: t('Click — switch the tab.'),
        stored: t('The chosen tab is remembered on this chart until the page is reloaded; nothing is saved.'),
        setting: "fe.ux.chartDrillTab",
        states: { "breakdown": t('Tab Breakdown'), "legend": t('Tab Legend') },
    }),
    // IE 2026 10 31 / ODOO-347310 (запрос Андрея: стрелка назад после разложения серий)
    'chart.line.splitBack': (v = {}, ctx = {}) => ({
        title: t('Back to the previous chart'),
        what: t('Shown while the chart is split by series with «Split the series» of the breakdown.'),
        click: t('Click — one split level back; after the last level the arrow disappears.'),
        stored: t('The levels are kept in memory until the page is reloaded; the widget is marked changed, you save it yourself.'),
        setting: "fe.ux.chartSplitBack",
    }),
    'chart.line.cog': (v = {}, ctx = {}) => ({
        title: t('Chart settings'),
        what: t('Settings button of this chart.'),
        why: t('Quick switches on hover, the full list of chart settings on click.'),
        click: t('Hover — quick settings panel (frequency, axes, grid, legend, click behaviour). Click — the settings window of this chart; click again — close it.'),
        affects: t('Changes apply to this chart only; some of them re-read its data.'),
        stored: t('Settings are written to the widget (viewParams) and kept after you save the widget.'),
        states: { "quick": t('Quick settings panel is shown') },
    }),
    'chart.line.qs.freq': (v = {}, ctx = {}) => ({
        title: t('Time step'),
        what: t('Step of the time axis: Multiple, Year, Month, Week, Days, Shifts.'),
        why: t('To look at the same data summed by a coarser or finer period.'),
        click: t('Click a value — the chart re-reads data with this step. Multiple — steps by date ranges of the widget’s frequency table (e.g. days first, then months). Clicking the active value returns to Multiple.'),
        affects: t('Re-reads the data of this widget.'),
        stored: t('Widget record (params.freq); kept after you save the widget.'),
        setting: "doc.params.freq (G | A | M | W | D | S), doc.params.freq_data",
        states: { "G": t('Multiple steps'), "A": t('By year'), "M": t('By month'), "W": t('By week'), "D": t('By day'), "S": t('By shift') },
    }),
    'chart.line.qs.selector': (v = {}, ctx = {}) => ({
        title: t('Range navigator'),
        what: t('Switch for a small navigator strip under the chart with the whole time range.'),
        why: t('To zoom into a part of a long horizon and move along it.'),
        click: t('Click — show / hide the strip. In the strip drag the window or its edges — the chart shows only that range.'),
        affects: t('Only the visible range of this chart; data is not re-read.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.chart-selector-use",
        states: { "on": t('Navigator strip is shown'), "off": t('Navigator strip is hidden') },
    }),
    'chart.line.qs.axisAnimation': (v = {}, ctx = {}) => ({
        title: t('Animation'),
        what: t('Switch for animated redrawing of the chart when data or axes change.'),
        why: t('Makes changes easier to follow; turn it off for faster, calmer redraws.'),
        click: t('Click — on / off.'),
        affects: t('Only how this chart is redrawn.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.animation_axisAnimation, animation_duration",
        states: { "on": t('Animation is on'), "off": t('Animation is off') },
    }),
    'chart.line.qs.gridY': (v = {}, ctx = {}) => ({
        title: t('Grid lines along Y'),
        what: t('Major and minor grid lines of the Y axis.'),
        why: t('Grid lines help to read values against the axis.'),
        click: t('Major — lines at labelled ticks; Minor — thinner lines between them. Click toggles each.'),
        affects: t('Only the look of this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.axisY-majorGrid, axisY-minorGrid",
    }),
    'chart.line.qs.gridX': (v = {}, ctx = {}) => ({
        title: t('Grid lines along X'),
        what: t('Major and minor grid lines of the X axis.'),
        why: t('Grid lines help to read values against the axis.'),
        click: t('Major — lines at labelled ticks; Minor — thinner lines between them. Click toggles each.'),
        affects: t('Only the look of this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.axisX-majorGrid, axisX-minorGrid",
    }),
    'chart.line.qs.axisYPos': (v = {}, ctx = {}) => ({
        title: t('Where the Y axis is'),
        what: t('Side of the plot where the Y axis with its labels is drawn: Auto, Left, Top, Right, Bottom.'),
        why: t('To free space or move labels where they do not cover the data.'),
        click: t('Click a side — move the axis there. Clicking the active side again hides the axis (None).'),
        affects: t('Only the look of this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.axisY-position",
        states: { "None": t('The axis is hidden'), "Auto": t('Automatic position'), "Left": t('On the left'), "Right": t('On the right'), "Top": t('At the top'), "Bottom": t('At the bottom') },
    }),
    'chart.line.qs.axisXPos': (v = {}, ctx = {}) => ({
        title: t('Where the X axis is'),
        what: t('Side of the plot where the X axis with its labels is drawn: Auto, Left, Top, Right, Bottom.'),
        why: t('To free space or move labels where they do not cover the data.'),
        click: t('Click a side — move the axis there. Clicking the active side again hides the axis (None).'),
        affects: t('Only the look of this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.axisX-position",
        states: { "None": t('The axis is hidden'), "Auto": t('Automatic position'), "Left": t('On the left'), "Right": t('On the right'), "Top": t('At the top'), "Bottom": t('At the bottom') },
    }),
    'chart.line.qs.compactY': (v = {}, ctx = {}) => ({
        title: t('Compact Y axes'),
        what: t('Y axes without titles, tick values drawn inside the plot.'),
        why: t('The plot takes the whole widget — useful for small widgets on a busy page.'),
        click: t('Click — on / off. When on, the value of the hovered point is also shown inside the plot.'),
        affects: t('Only the look of this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.compact-axisY (fallback axes-compact); fe.ux.chartCompactTight",
        states: { "on": t('Compact Y axes'), "off": t('Regular Y axes') },
    }),
    'chart.line.qs.compactX': (v = {}, ctx = {}) => ({
        title: t('Compact X axis'),
        what: t('Date axis shows only a narrow strip of years, no month labels.'),
        why: t('Gives the height back to the plot.'),
        click: t('Click — on / off. When on, the hovered month is shown as a tag inside the plot.'),
        affects: t('Only the look of this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.compact-axisX (fallback axes-compact)",
        states: { "on": t('Compact X axis'), "off": t('Regular X axis') },
    }),
    'chart.line.qs.axisXLegend': (v = {}, ctx = {}) => ({
        title: t('Date label tiers'),
        what: t('Which tiers of date labels the X axis shows: Auto, Year-Month-Week-Day, Year-Month-Week, Year-Month, Year.'),
        why: t('To make the date axis readable at the current step and width.'),
        click: t('Click a variant — the axis is rebuilt with these tiers. Clicking the active one returns to Auto.'),
        affects: t('Only the axis labels of this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.axisX-legend (Auto | D | W | M | A)",
    }),
    'chart.line.qs.hoverLink': (v = {}, ctx = {}) => ({
        title: t('Linked highlight'),
        what: t('Links the series highlight of this chart with other charts of the page.'),
        why: t('Hover a country or a measure here and see it highlighted in all related charts at once.'),
        click: t('Click — on / off. The highlight works between charts that have this option on.'),
        affects: t('Other charts of the same page with this option on highlight the series of the same name; nothing is re-read.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.hover-link = 'page'; fe.ux.chartHoverLink",
        states: { "on": t('Linked with other charts of the page'), "off": t('Highlight only in this chart') },
    }),
    'chart.line.qs.clickOpenRow': (v = {}, ctx = {}) => ({
        title: t('Click opens the row'),
        what: t('Chooses what a click on a point does.'),
        // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): состояние drill — опция выключена и у графика включена форма расшифровки (AttrChart UI_HELP_QS_LINE_STATE); off — прежний клик
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): состояние tab — опция выключена, расшифровка во вкладке Breakdown окна легенды
        why: ctx.state === 'tab' ? t('By default a click opens the legend window at the date of the point, its Breakdown tab shows what the value consists of; turn this on if you need the data row behind the point.')
            : ctx.state === 'drill' ? t('By default a click opens the breakdown form of the point (Alt+click — the legend window); turn this on if you need the data row behind the point.') : t('By default a click works with the legend window; turn this on if you need the data row behind the point.'),
        click: ctx.state === 'tab' ? t('Off (default) — a click opens the legend window at the date of the point, its Breakdown tab shows the breakdown of the point; Alt+click leaves the legend window as it is. On — a click opens the row widget of the point; the open legend still follows the point.')
            : ctx.state === 'drill' ? t('Off (default) — a click opens the breakdown form of the point; Alt+click — the legend window (opens it or moves its values to the date of the point). On — a click opens the row widget of the point; the open legend still follows the point.') : t('Off (default) — a click opens the legend window or moves its values to the date of the point. On — a click opens the row widget of the point; the open legend still follows the point.'),
        affects: t('On: opens a child row widget next to the chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.click-open-row; fe.ux.chartClickLegend",
        states: { "on": t('A click opens the row widget'), "off": t('A click works with the legend window'), "drill": t('A click opens the breakdown form'), "tab": t('A click opens the breakdown in the legend window') },   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): drill · IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): tab
    }),
    // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): кнопка «Breakdown form» ряда «Click on a point:» (viewParams.<chart>.click-drill)
    // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): кнопка — «Breakdown» (у графика с окном легенды расшифровка — вкладка окна, без окна — форма у кусочка); состояние tab — вкладка
    'chart.line.qs.clickDrill': (v = {}, ctx = {}) => ({
        title: t('Breakdown'),
        what: t('Chooses whether a click on a point or a bar shows its breakdown — what the value consists of.'),
        why: t('The breakdown shows what the value consists of by the dimensions of the data source (the first values and «Others») and can split the series in this chart: on a chart with the legend window — in its Breakdown tab, otherwise — in a form at the point.'),
        click: ctx.state === 'tab' ? t('On (default) — a click on a point or a bar opens the legend window at its date with the breakdown in the Breakdown tab; Alt+click leaves the legend window as it is. Off — a click works with the legend window, as before.')
            : t('On (default) — a click on a point or a bar opens the breakdown form, Alt+click — the legend window. Off — a click works with the legend window, as before.'),
        affects: t('Only this chart. With «Opens the row widget» on, a click opens the row widget instead of the breakdown.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.click-drill; fe.ux.chartDrill; fe.ux.chartDrillTab",
        states: { "on": t('A click opens the breakdown form'), "off": t('A click works with the legend window'), "tab": t('A click opens the breakdown in the legend window') },
    }),
    'chart.line.qs.legendPos': (v = {}, ctx = {}) => ({
        title: t('Legend place'),
        what: t('Where the legend is: on a side of the plot (Auto, Left, Top, Right, Bottom) or in its own window (Popup).'),
        why: t('Popup gives the full legend: groups, checkboxes, values by date, series for the filter; a side legend is just names.'),
        click: t('Click a value. Popup opens the legend window and shows the legend button in the corner. Clicking the active side hides the legend.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<chart>.legend-position (Auto | Left | Top | Right | Bottom | Popup), legend-grouped, legend-popup",
        states: { "Popup": t('Own legend window'), "None": t('No legend'), "Auto": t('Legend on the right'), "Left": t('Legend on the left'), "Top": t('Legend at the top'), "Right": t('Legend on the right'), "Bottom": t('Legend at the bottom') },
    }),
    'chart.line.plot': (v = {}, ctx = {}) => ({
        title: t('Chart area'),
        what: t('The plot itself: points, bars and lines of the series.'),
        why: t('Main place to read the data and pick a date or a period.'),
        // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика): v.drill — у графика включена форма расшифровки (AttrChart.uiHelp6_plotTip): клик открывает форму, окно легенды — Alt+клик
        // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): v.drill 2 — расшифровка во вкладке Breakdown окна легенды, v.tipOff — плашки значений у точки нет (значения — во вкладке Legend окна): текст
        // собирается из предложений (chartPlotClick6); прежние сочетания (drill 0 / 1 без tipOff) — прежние тексты целиком
        click: (v.drill === 2 || v.tipOff) ? chartPlotClick6(v, ctx)
            : v.drill ? (ctx.state === 'values' ? t('Move along the dates — a vertical line and a plate with the values of all series at the nearest date; the series keep their look. Hover a row of the legend window — the other series fade. Click a point or a bar — its breakdown form opens (what the value consists of by the dimensions of the source, a command to split the series); an open legend window moves to that date. Alt+click — the legend window instead of the form (Legend position = Popup). Drag along the dates (or Shift+click) — select a period.')
            : t('Hover a line / bar — the other series fade (a single series stays as it is), its value and date appear at the axes. Click a point or a bar — its breakdown form opens (what the value consists of by the dimensions of the source, a command to split the series); an open legend window moves to that date. Alt+click — the legend window instead of the form (Legend position = Popup). Drag along the dates (or Shift+click) — select a period.'))
            : ctx.state === 'values'   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): проход мышью — значения всех серий на дате, серии не приглушаются
            ? t('Move along the dates — a vertical line and a plate with the values of all series at the nearest date; the series keep their look. Hover a row of the legend window — the other series fade. Click a point — the legend window (Legend position = Popup) opens or shows the values of that date; Alt+click skips this. Drag along the dates (or Shift+click) — select a period.')
            : t('Hover a line / bar — the other series fade (a single series stays as it is), its value and date appear at the axes. Click a point — the legend window (Legend position = Popup) opens or shows the values of that date; Alt+click skips this. Drag along the dates (or Shift+click) — select a period.'),   // IE 2026 09 26 / ODOO-… (замечание Игоря: выделение серий графика)
        affects: t('The selected period goes to the workspace period chip if this chart is the period selector, otherwise to widgets of the page that accept the date selection.'),
        stored: t('Chosen date — memory; the period — in the period chip / page selection.'),
        hotkey: (v.drill && v.drill !== 2) ? t('Shift+click — extend the selected period; Alt+click — the legend window instead of the breakdown form (with «Click on a point: Opens the row widget» on — only the row window opens)') : t('Shift+click — extend the selected period; Alt+click — leave the legend window as it is (with «Click on a point: Opens the row widget» on — only the row window opens)'),   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика)
        setting: "fe.ux.chartClickLegend; viewParams.<chart>.click-open-row; selection_fields date (Selector set / Set / Get); localStorage chart.hover; fe.ux.chartHoverDimOthers; fe.ux.chartHoverValues; fe.ux.chartDrill; viewParams.<chart>.click-drill / drill-dims / drill-top; fe.ux.chartDrillTab; fe.ux.chartPointTipOff",   // IE 2026 09 26 / ODOO-… (заказ Игоря: расшифровка кусочка графика) · IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды)
        states: { "values": t('Values at the date: moving the mouse shows all series at the nearest date and does not restyle them') },   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
    }),
    // IE 2026 09 30 / ODOO-343343 (заказ Игоря: начало плана штриховкой — объяснение по Alt у флажков): флажок и полоса начала плана на графике (AttrChart.planStart_tip)
    'chart.planStart': (v = {}, ctx = {}) => ({
        title: t('Plan start'),
        what: t('The plan starts here: to the left of the hatched band with the flag is fact, to the right is plan (the date is the Stock date of the report).'),
        why: t('Shows at a glance which part of the chart is already fact and which is plan.'),
        affects: t('Only the look.'),
        setting: 'fe.ux.planStartMark',
    }),
    'chart.line.selectionZone': (v = {}, ctx = {}) => ({
        title: t('Selected period'),
        what: t('Rounded frame over the chosen dates.'),
        why: t('Shows which period is selected and sent to the filter.'),
        how: t('Frame = selected dates. On a period-selector chart it always shows the workspace period chip.'),
        affects: t('The same period is used by the period chip or by other widgets of the page.'),
        stored: t('Memory / period chip.'),
        setting: "selection_fields: date (Selector set → period chip; Set / Get → page selection)",
    }),
    'chart.line.hoverTags': (v = {}, ctx = {}) => ({
        title: t('Point under the cursor'),
        what: t('Tags with the date (X) and the value (Y) of the point under the cursor, in the colour of its series, and a ring on the point.'),
        why: t('Read the exact value without opening anything.'),
        how: t('The value is shown at the axis of that series (right axis for stock cover, etc.); durations are in months / days.'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        affects: t('The legend window, if open and not frozen, shows the same date.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "fe.ux.chartHoverMarkAxisLabel; localStorage chart.hover (window.chartHover); fe.ux.chartHoverValues (on — «Values at the date» instead of these tags)",
    }),
    // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии): вертикаль, точки линий и плашка значений всех серий на дате под курсором
    // IE 2026 09 29 / ODOO-343341 (заказ Игоря: вкладка расшифровки в окне легенды): v.tipOff — у графика с окном легенды плашки у точки нет (заказ Игоря: «не показывай tooltip для точки — при необходимости можно открыть
    // легенду и увидеть его там»): значения на дате — во вкладке Legend окна легенды
    'chart.line.hoverValues': (v = {}, ctx = {}) => ({
        title: t('Values at the date'),
        what: v.tipOff ? t('A vertical line at the date nearest to the cursor, dots on the lines and the date at the axis. There is no plate at the point on a chart with the legend window: the values of all series at that date are in the Legend tab of the window.')
            : t('A vertical line at the date nearest to the cursor, dots on the lines and a plate with the values of all series at that date, largest first (series of another axis go below). The row of the series nearest to the cursor is marked.'),
        why: t('To read all series at a date while moving the mouse — the chart does not fade or highlight series on the way.'),
        how: v.tipOff ? t('Open the legend window (the button in the corner of the chart) and its Legend tab — it follows the date under the cursor, the row of the series nearest to the cursor is marked. Hover a row of the legend window — the other series fade. Rest the cursor on a point of a series by country, supplier, … — its badge with the filter checkbox appears.')
            : t('Row colours are the series colours; «+N more» — rows that do not fit. With the legend window open the plate is hidden: the window shows the same values. Hover a row of the legend window — the other series fade. Rest the cursor on a point of a series by country, supplier, … — its badge with the filter checkbox appears.'),
        affects: t('The legend window (if open and not frozen by a click) follows the same date.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: v.tipOff ? "fe.ux.chartPointTipOff (false — the plate at the point, as before); fe.ux.chartHoverValues; fe.data.chartHoverBadgeDwellMs"
            : "fe.ux.chartHoverValues (false — fade the other series on hover, as before); fe.data.chartHoverValuesRows; fe.data.chartHoverBadgeDwellMs",
    }),
    'chart.line.hoverHighlight': (v = {}, ctx = {}) => ({
        title: t('Highlighted series'),
        what: t('The series in focus keeps its look, the other series fade; a label with its name appears over its axis. Focus comes from a row of the legend window under the cursor or from the same series in a linked chart; with «Values at the date» off — also from the series under the cursor. A single series is not highlighted.'),   // IE 2026 09 27 / ODOO-… (заказ Игоря: вариант A наведения на серии)
        why: t('Shows which line / bars and which axis you are looking at.'),
        how: t('Faded series are only dimmed, not hidden. Bars of receipts / issues of a stock step stay bright with it.'),
        affects: t('With «Series highlight: Linked on the page» the same series is highlighted in other charts of the page.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "fe.ux.chartHoverDimOthers, fe.ux.chartHoverDimOpacity, fe.ux.chartHoverValues; localStorage chart.hover (window.chartHover.set(false)); viewParams.<chart>.hover-link",
    }),
    'chart.line.hoverBadge.check': (v = {}, ctx = {}) => ({
        title: t('Filter by this series'),
        what: t('Checkbox in the badge of the hovered point: puts the value of this series (country, supplier, …) into the workspace filter.'),
        why: t('Pick a country / object right on the chart and see other widgets filtered by it.'),
        click: t('Click — add / remove the value in the chip. The badge stays while you move the cursor from the point to it.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read. This chart usually keeps all its series (its own selector field is «Set» only).'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        setting: "viewList measure series_dimension; params.selection_fields (selector_set) / fieldSelectors",
        states: { "on": t('The value is in the filter chip'), "off": t('The value is not in the filter') },
    }),
    'chart.line.legendTether': (v = {}, ctx = {}) => ({
        title: t('Link to the legend'),
        what: t('Orange dashed line from the chart point to the legend window.'),
        why: t('Shows which point the legend values belong to.'),
        how: t('The line ends at the frozen point, else at the point under the cursor, else at the selected period. On the fields tab it points to the field row.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.line.emptyMsg': (v = {}, ctx = {}) => ({
        title: t('Nothing to draw'),
        what: t('Message instead of an empty plot.'),
        why: t('Empty axes with a 0…0.05 scale would say nothing.'),
        how: t('«No data» — the filters (chips, period) leave no rows; «All values are zero» — rows exist but every value is 0.'),
        affects: t('Change chips or the period to see data.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "fe.ux.chartEmptyMessage",
        states: { "empty": t('No data for the current filters'), "zero": t('All values are zero') },
    }),
    'chart.line.negZone': (v = {}, ctx = {}) => ({
        title: t('Below zero'),
        what: t('Tinted band below zero and a bold zero line.'),
        why: t('Negative values (shortage, returns, mirrored issues) are visible at a glance.'),
        how: t('Everything in the tinted band is below zero on the main axis.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.line.alarmZones': (v = {}, ctx = {}) => ({
        title: t('Zones'),
        what: t('Coloured bands set up for this chart (by dates and / or value ranges).'),
        why: t('Mark periods or levels that matter (norm, shortage, month of interest).'),
        how: t('Colour meaning comes from the chart settings: usually green — norm, yellow / orange — warning, red — critical, grey — out of scope.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "attr.drawAlarmZone [{xMin, xMax, yMin, yMax, cssClass, style, rows}]",
    }),
    'chart.line.stockLevels': (v = {}, ctx = {}) => ({
        title: t('Stock level colours'),
        what: t('The stock line is coloured by the stock level of each period.'),
        why: t('See at once where stock is out, low, normal or excessive.'),
        how: t('Red — out of stock; orange — below min; yellow — plan zone; light blue — neutral; dark green — over stock; grey — no sales.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "attr.chartType; binding_stock / binding_LS / binding_in / binding_out / binding_wo",
    }),
    'chart.line.hatch': (v = {}, ctx = {}) => ({
        title: t('Hatched bars'),
        what: t('Bars in the colour of a measure with red diagonal hatch.'),
        why: t('Shows the part of a flow that is not covered (cannot be fulfilled) next to the covered part.'),
        how: t('Same colour as the base measure + red hatch = the uncovered part of that measure.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "field hatch_base / hatch_color / stack_on; fe.ux.chartHatch; fe.ux.chartStackOverlay",
    }),
    'chart.line.axisShort': (v = {}, ctx = {}) => ({
        title: t('Short numbers'),
        what: t('Axis labels like 250K or 20M.'),
        why: t('Saves room for the plot; all labels of an axis use one unit.'),
        how: t('K — thousands, M — millions, B — billions.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "attr / field 'axisY-short' = false — off",
    }),
    'chart.line.rangeSelector': (v = {}, ctx = {}) => ({
        title: t('Range navigator'),
        what: t('Small area chart of the whole horizon with a movable window.'),
        why: t('Zoom into part of a long horizon.'),
        click: t('Drag the window or its edges — the main chart shows only that range.'),
        affects: t('Only the visible X range of this chart.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "viewParams.<chart>.chart-selector-use",
    }),
    'chart.line.legacy.clearVisibility': (v = {}, ctx = {}) => ({
        title: t('Hide all series'),
        what: t('Hides all series of the chart (legacy chart buttons).'),
        why: t('Old chart toolbar kept for compatibility.'),
        click: t('Click — apply.'),
        affects: t('The data table and the chart of this widget.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "attr.buttonsChart",
    }),
    'chart.line.legacy.defaultVisibility': (v = {}, ctx = {}) => ({
        title: t('Default series'),
        what: t('Shows only the default series (baseline and forecast).'),
        why: t('Old chart toolbar kept for compatibility.'),
        click: t('Click — apply.'),
        affects: t('The data table and the chart of this widget.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "attr.buttonsChart",
    }),
    'chart.line.legacy.minimize': (v = {}, ctx = {}) => ({
        title: t('Smaller chart'),
        what: t('Gives most of the widget to the data table (table 80 %).'),
        why: t('Old chart toolbar kept for compatibility.'),
        click: t('Click — apply.'),
        affects: t('The data table and the chart of this widget.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "attr.buttonsChart",
    }),
    'chart.line.legacy.maximize': (v = {}, ctx = {}) => ({
        title: t('Bigger chart'),
        what: t('Gives most of the widget to the chart (table 10 %).'),
        why: t('Old chart toolbar kept for compatibility.'),
        click: t('Click — apply.'),
        affects: t('The data table and the chart of this widget.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "attr.buttonsChart",
    }),
    'chart.line.legacy.close': (v = {}, ctx = {}) => ({
        title: t('Close the chart'),
        what: t('Hides the chart tab and gives the whole widget to the table.'),
        why: t('Old chart toolbar kept for compatibility.'),
        click: t('Click — apply.'),
        affects: t('The data table and the chart of this widget.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "attr.buttonsChart",
    }),
    'chart.line.mobileTapBubble': (v = {}, ctx = {}) => ({
        title: t('Values of the tapped date'),
        what: t('Bubble with the values of all series at the tapped date.'),
        why: t('Read values on a phone without opening the row window.'),
        click: t('Open row — the data row of that date; Close — hide the bubble. A long press on a point opens the row directly.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "window.mobileUi.set('chartTapValues', false)",
    }),
    'chart.line.mobileLegendSheet': (v = {}, ctx = {}) => ({
        title: t('Chart series'),
        what: t('Sheet with the series of the chart; tap a row to show or hide the series.'),
        why: t('Large rows are easier to tap than the tiny legend.'),
        click: t('Tap a row — show / hide the series; a spinner means the chart is redrawing.'),
        affects: t('Only this chart.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "window.mobileUi.set('chartLegendSheet', false)",
    }),
    'chart.line.pieLabels': (v = {}, ctx = {}) => ({
        title: t('Slice labels'),
        what: t('Category name and share next to each slice.'),
        why: t('A pie has no legend here — the labels are the legend.'),
        how: t('Small slices (under 3 %) and colliding labels have no label — hover the slice for its value.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.line.lowerArea': (v = {}, ctx = {}) => ({
        title: t('Lower area'),
        what: t('A second plot area under the main one for some measures.'),
        why: t('Keeps small flows readable next to big stock lines.'),
        how: t('Both areas use the same scale, so bar heights compare directly; the lower area is as tall as its data.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "'axisX-sameScale', 'plot-row-minHeight'; fe.ux.plotRowFit",
    }),

    // ---- legend (21) ----
    'chart.legend.window': (v = {}, ctx = {}) => ({
        title: t('Legend window'),
        what: t('Free window with the legend of the chart: groups of measures, their series, checkboxes and values.'),
        why: t('Keeps the plot clean and gives exact values, series switches and filter checkboxes in one place.'),
        click: t('Drag the header to move the window. It closes with the × or together with the widget.'),
        affects: t('Hides while another tab of the widget is shown (except the fields tab it belongs to).'),
        stored: t('Position — memory while the widget is open; not saved.'),
        setting: "fe.ux.legendFollowsOwner; fe.ux.legendStableSize",
    }),
    'chart.legend.close': (v = {}, ctx = {}) => ({
        title: t('Close the legend'),
        what: t('Closes the legend window.'),
        click: t('Click — close. Open it again with the legend button in the corner of the chart.'),
        affects: t('Removes the orange link line to the chart.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.expandAll': (v = {}, ctx = {}) => ({
        title: t('Expand all groups'),
        what: t('Opens every group of the legend.'),
        why: t('Quick way to see all series or only the group headers.'),
        click: t('Click — apply to all groups. Ctrl/Cmd+click on the arrow of one group does the same.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.collapseAll': (v = {}, ctx = {}) => ({
        title: t('Collapse all groups'),
        what: t('Folds every group of the legend.'),
        why: t('Quick way to see all series or only the group headers.'),
        click: t('Click — apply to all groups. Ctrl/Cmd+click on the arrow of one group does the same.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.checkAll': (v = {}, ctx = {}) => ({
        title: t('All series'),
        what: t('Checkbox in the header of the legend: all series shown, some, or none.'),
        why: t('Hide everything and then switch on only what you need, or show all back.'),
        click: t('Click — show all series if not all are shown, otherwise hide all. In a bubble chart the rows are colour classes of the points.'),
        affects: t('Axes without a shown series are hidden; axis ranges fit the shown series.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "all": t('All series are shown'), "some": t('Some series are hidden'), "none": t('All series are hidden') },
    }),
    'chart.legend.groupCheck': (v = {}, ctx = {}) => ({
        title: t('Group on / off'),
        what: t('Checkbox of a group: all its series shown, some, or none.'),
        why: t('Switch a whole measure (all its countries, objects…) at once.'),
        click: t('Click — show all series of the group, or hide them all if all are shown.'),
        affects: t('Axes without a shown series are hidden. If the widget follows the page measure selector, other widgets show the same measures.'),
        stored: t('Only this view while the chart is open; not saved.'),
        states: { "all": t('All series of the group are shown'), "some": t('Some series of the group are hidden'), "none": t('The group is hidden') },
    }),
    'chart.legend.seriesCheck': (v = {}, ctx = {}) => ({
        title: t('Series on / off'),
        what: t('Checkbox of one series.'),
        why: t('Remove a line or bars from the plot without changing the widget.'),
        click: t('Click — show / hide the series; a hidden series stays in the legend, faded and struck through. In a bubble chart the rows are colour classes of the points.'),
        affects: t('Axes without a shown series are hidden; axis ranges fit the shown series.'),
        stored: t('Only this view while the chart is open (kept when data is re-read); not saved.'),
        states: { "on": t('The series is shown'), "off": t('The series is hidden') },
    }),
    'chart.legend.selCheck': (v = {}, ctx = {}) => ({
        title: t('Filter by this series'),
        what: t('Second checkbox of a series row (accent colour): puts the value of this series into the workspace filter chip.'),
        why: t('Select countries / objects straight from the legend.'),
        click: t('Click — add / remove the value in the chip.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read. This chart usually keeps all its series (its own selector field is «Set» only).'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        setting: "params.selection_fields (selector_set) / fieldSelectors; viewList series_dimension",
        states: { "on": t('The value is in the filter chip'), "off": t('The value is not in the filter') },
    }),
    'chart.legend.glyph': (v = {}, ctx = {}) => ({
        title: t('Series sign'),
        what: t('Small picture of the series: its colour and type (line, area, bars, dots).'),
        why: t('Find the series on the plot.'),
        how: t('Colour = the colour on the chart; the shape shows the type. A red-hatched swatch — the uncovered part of a measure. In a bubble chart the rows are colour classes of the points.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.legend.name': (v = {}, ctx = {}) => ({
        title: t('Series name'),
        what: t('Name of a series or of a measure group.'),
        why: t('Jump to the settings of the measure and change the order of series.'),
        click: t('Click a series — the fields tab of the widget opens at its measure. Alt+click a measure group — the same for the measure. Alt+drag a row — change the order (Esc — cancel). Hovering a row highlights the series on the chart. In a bubble chart the rows are colour classes of the points.'),
        affects: t('Alt+drag changes the order of fields of the widget — the widget is marked as changed.'),
        stored: t('Order — widget fields (doc.viewList), kept after you save the widget; z-order by Alt+↑/↓ — memory.'),
        hotkey: t('Alt+drag — reorder; Alt+↑/↓ — bring forward / backward; Alt+click on a group — measure settings'),
        setting: "doc.viewList (order), series_binding",
    }),
    'chart.legend.groupCount': (v = {}, ctx = {}) => ({
        title: t('Series in the group'),
        what: t('Number of series in this group.'),
        why: t('Shows how many countries / objects a measure is split into.'),
        how: t('The number counts all series of the group with any non-zero value, shown or hidden.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.legend.groupChevron': (v = {}, ctx = {}) => ({
        title: t('Fold the group'),
        what: t('Arrow that folds / unfolds the series of a group.'),
        why: t('Long splits (more than 30 series) start folded.'),
        click: t('Click — fold / unfold this group; Ctrl/Cmd+click — all groups.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        hotkey: t('Ctrl/Cmd+click — all groups'),
    }),
    'chart.legend.colPeriod': (v = {}, ctx = {}) => ({
        title: t('Values at a date'),
        what: t('Column with the value of every series at one date; the date is in the column header.'),
        why: t('Compare all series at the same moment.'),
        how: t('Bold date — the point you clicked (frozen). Grey date — the point under the cursor. «Period» — the latest value of each series.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "frozen": t('Values at the clicked point'), "hover": t('Values at the point under the cursor'), "last": t('Latest values') },
    }),
    'chart.legend.unfreeze': (v = {}, ctx = {}) => ({
        title: t('Unfreeze'),
        what: t('Cross next to the frozen date.'),
        why: t('Return the legend to following the cursor.'),
        click: t('Click — the legend again shows the point under the cursor (or the latest values). The comparison columns disappear.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.colTotal': (v = {}, ctx = {}) => ({
        title: t('Total of the period'),
        what: t('Column with the total of each series over the selected period.'),
        why: t('Totals of a quarter / season without a separate report.'),
        how: t('Flows are summed; durations (stock cover, days) are averaged. The header shows the period.'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.colPoint': (v = {}, ctx = {}) => ({
        title: t('Point column'),
        what: t('Value of each series at the point under the cursor (date in the header).'),
        why: t('Compare any date with the frozen one without calculations.'),
        how: t('Freeze a point with a click, then move the cursor over other dates.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.colDelta': (v = {}, ctx = {}) => ({
        title: t('Δ column'),
        what: t('Difference: point under the cursor minus the frozen point; green — more, red — less.'),
        why: t('Compare any date with the frozen one without calculations.'),
        how: t('Freeze a point with a click, then move the cursor over other dates.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.colDeltaPct': (v = {}, ctx = {}) => ({
        title: t('Δ % column'),
        what: t('Relative difference from the frozen point, in %.'),
        why: t('Compare any date with the frozen one without calculations.'),
        how: t('Freeze a point with a click, then move the cursor over other dates.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.legend.rowHighlight': (v = {}, ctx = {}) => ({
        title: t('Row of the hovered series'),
        what: t('Legend row of the series you are pointing at on the chart.'),
        why: t('Links the plot with its legend row.'),
        how: t('Bold row with a violet bar on the left = the series under the cursor (or the class of the hovered bubble).'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.legend.offRow': (v = {}, ctx = {}) => ({
        title: t('Hidden series'),
        what: t('Faded, struck-through row.'),
        why: t('The series is still listed so you can switch it back.'),
        how: t('Faded and struck through = hidden on the chart; tick its checkbox to show it again.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.legend.footer': (v = {}, ctx = {}) => ({
        title: t('Node values'),
        what: t('Bottom block of the legend with the values of one bubble: size, X, Y and extra fields.'),
        why: t('Read a node without a tooltip covering the chart.'),
        how: t('Shows the node under the cursor; when the cursor leaves, the node you clicked. After Shift+drag — totals of the selected nodes and counts per class.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "attr.bubble_picker_fields; fe.ux.legendStableSize",
        states: { "hover": t('Node under the cursor'), "selected": t('Selected node'), "rect": t('Totals of the selected nodes'), "empty": t('No node yet') },
    }),

    // ---- bubble (24) ----
    'chart.bubble.legendBtn': (v = {}, ctx = {}) => ({
        title: t('Legend window'),
        what: t('Opens the legend window of the bubbles: colour classes with point counts and the values of a node.'),
        why: t('See what each colour means, hide classes and read the values of a node.'),
        click: t('Click — open / close. While the window is open the class strip beside the plot is hidden.'),
        affects: t('Only this chart.'),
        stored: t('Memory; not saved. The window is not opened automatically when the widget opens.'),
        setting: "viewParams.<bubble>.legend-grouped (default true), legend-position = Popup",
        states: { "on": t('The legend window is open'), "off": t('The legend window is closed') },
    }),
    'chart.bubble.cog': (v = {}, ctx = {}) => ({
        title: t('Quick settings'),
        what: t('Opens the quick settings of the bubble chart: zoom, log scale, axes, legend.'),
        why: t('Adjust how the bubbles are shown without the settings window.'),
        click: t('Hover or click — show / hide the panel.'),
        affects: t('Only this chart.'),
        stored: t('Values are written to the widget (viewParams) and kept after you save it.'),
        setting: "fe.ux.chartSettingsHoverMs; fe.ux.hoverHideMs",
    }),
    'chart.bubble.zoomIn': (v = {}, ctx = {}) => ({
        title: t('Zoom in'),
        what: t('Enlarges the view around its centre (×0.7 of the visible range).'),
        why: t('Bubbles often cluster near zero — zoom to separate them.'),
        click: t('Click — apply. Only the axes chosen in «Wheel zoom» are zoomed. The mouse wheel does the same.'),
        affects: t('Only the view of this chart.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "viewParams.<bubble>.bubble_axes (XY | X | Y), bubble_gestures",
    }),
    'chart.bubble.zoomOut': (v = {}, ctx = {}) => ({
        title: t('Zoom out'),
        what: t('Shows a wider range around the centre.'),
        why: t('Bubbles often cluster near zero — zoom to separate them.'),
        click: t('Click — apply. Only the axes chosen in «Wheel zoom» are zoomed. The mouse wheel does the same.'),
        affects: t('Only the view of this chart.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "viewParams.<bubble>.bubble_axes (XY | X | Y), bubble_gestures",
    }),
    'chart.bubble.zoomReset': (v = {}, ctx = {}) => ({
        title: t('Reset zoom'),
        what: t('Returns the whole data range (axis limits from the settings).'),
        why: t('Bubbles often cluster near zero — zoom to separate them.'),
        click: t('Click — apply. Only the axes chosen in «Wheel zoom» are zoomed. The mouse wheel does the same.'),
        affects: t('Only the view of this chart.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "viewParams.<bubble>.bubble_axes (XY | X | Y), bubble_gestures",
    }),
    'chart.bubble.qs.wheelZoom': (v = {}, ctx = {}) => ({
        title: t('Mouse wheel zoom'),
        what: t('Which axes the mouse wheel / pinch and the zoom island change: both, X only, Y only, or none.'),
        why: t('Zoom along one axis keeps the other scale steady.'),
        click: t('Click a variant. Off — no wheel zoom and no zoom island.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<bubble>.bubble_axes, bubble_gestures",
        states: { "XY": t('Both axes'), "X": t('X only'), "Y": t('Y only'), "off": t('Off') },
    }),
    'chart.bubble.qs.logScale': (v = {}, ctx = {}) => ({
        title: t('Logarithmic axes'),
        what: t('Logarithmic scale (base 10) for X and / or Y.'),
        why: t('When values differ thousands of times, a log scale keeps both small and big nodes readable.'),
        click: t('Click X or Y — on / off for that axis.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<bubble>.axisX-logBase, axisY-logBase",
    }),
    'chart.bubble.qs.axisYPos': (v = {}, ctx = {}) => ({
        title: t('Where the Y axis is'),
        what: t('Side of the Y axis: Auto, Left, Right.'),
        why: t('Move the axis away from the busy corner.'),
        click: t('Click a side. Clicking the active one returns to Auto.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<bubble>.axisY-position",
    }),
    'chart.bubble.qs.axisXPos': (v = {}, ctx = {}) => ({
        title: t('Where the X axis is'),
        what: t('Side of the X axis: Auto, Top, Bottom.'),
        why: t('Move the axis away from the busy corner.'),
        click: t('Click a side. Clicking the active one returns to Auto.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<bubble>.axisX-position",
    }),
    'chart.bubble.qs.compactY': (v = {}, ctx = {}) => ({
        title: t('Compact Y axis'),
        what: t('Tick labels and the Y axis title inside the plot area (on by default).'),
        why: t('The plot takes the whole widget.'),
        click: t('Click — on / off. A date axis keeps its year tier below the plot.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<bubble>.compact-axisY",
        states: { "on": t('Compact'), "off": t('Regular axis') },
    }),
    'chart.bubble.qs.compactX': (v = {}, ctx = {}) => ({
        title: t('Compact X axis'),
        what: t('Tick labels and the X axis title inside the plot area (on by default).'),
        why: t('The plot takes the whole widget.'),
        click: t('Click — on / off. A date axis keeps its year tier below the plot.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<bubble>.compact-axisX",
        states: { "on": t('Compact'), "off": t('Regular axis') },
    }),
    'chart.bubble.qs.legendPos': (v = {}, ctx = {}) => ({
        title: t('Class strip place'),
        what: t('Where the colour classes are shown: a strip beside the plot (Auto = below, Left, Top, Right, Bottom) or only the legend window (Popup).'),
        why: t('Choose between an always-visible strip and a window with counts and toggles.'),
        click: t('Click a value. Popup opens the legend window and hides the strip.'),
        affects: t('Only this chart.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<bubble>.legend-position, legend-popup, legend-grouped",
    }),
    'chart.bubble.plot': (v = {}, ctx = {}) => ({
        title: t('Bubble area'),
        what: t('Each bubble is one node (e.g. product × warehouse): X and Y — two measures, size — a third one, colour — its class.'),
        why: t('Find outliers and groups of nodes at a glance.'),
        click: t('Hover — ring and values at the axes. Click a bubble — select it; its dimensions plate follows the cursor; click it again — deselect. Shift+drag — select nodes in a rectangle. Esc — clear. Mouse wheel — zoom.'),
        affects: t('Selecting nodes in the plate puts them into the workspace filter (see the plate checkbox).'),
        stored: t('Selection of nodes — memory; filter — workspace chip.'),
        hotkey: t('Shift+drag — rectangle; Esc — clear selection'),
        setting: "fe.ux.bubbleHoverTags; viewParams.<bubble>.bubble_axes / bubble_gestures",
    }),
    'chart.bubble.point': (v = {}, ctx = {}) => ({
        title: t('How to read a bubble'),
        what: t('Colour, size and outline of a bubble.'),
        how: t('Size — the size measure; colour — its class (see the legend). Purple with a number — the node is in the filter (number = its place in the selection, same on all linked bubble charts); pale — not selected while a filter is set; dark outline — selected by click or rectangle; orange outline — highlighted from another widget.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "bubble_class_binding / bubble_class_colors, bubble_level_binding / _low / _high, bubble_activeColor, bubble_minSize / bubble_maxSize",
    }),
    'chart.bubble.classStrip': (v = {}, ctx = {}) => ({
        title: t('Colour classes'),
        what: t('Strip with the colour classes of the bubbles (e.g. OOS, Low, Normal, High).'),
        why: t('Tells what each bubble colour means.'),
        how: t('Each chip — a colour and its class name. If this chart allows it, a click hides / shows the bubbles of that class.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "bubble_legend_toggle; rules of bubble_level_binding; bubble_class_colors",
    }),
    'chart.bubble.picker': (v = {}, ctx = {}) => ({
        title: t('Node plate'),
        what: t('Plate next to the cursor with the dimensions of the node (product, warehouse…) and, when the legend is closed, its values.'),
        why: t('Pick a node for the filter or open its record right from the chart.'),
        click: t('Follows the cursor over nodes while the plate mode is on. Click the same node again, click outside or press Esc to close it.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        hotkey: t('Esc — close'),
    }),
    'chart.bubble.picker.check': (v = {}, ctx = {}) => ({
        title: t('Select the node'),
        what: t('Checkbox of the node in the plate: puts this exact node (e.g. product × warehouse) into the workspace filter.'),
        why: t('Collect problem nodes and see only them in the other widgets.'),
        click: t('Click — add / remove the node. The selected node turns purple with its number.'),
        affects: t('Workspace chip «Positions» (exact pairs) — widgets of the page are re-read; rows with the same object / subject are highlighted in widgets that accept it. Bubble charts of one group share the selection.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this node'),
        setting: "bubble_select_mode (pair | dims), bubble_pair_group; params.fieldSelectors; selection_fields Set / Get",
        states: { "on": t('The node is in the filter'), "off": t('The node is not selected') },
    }),
    'chart.bubble.picker.open': (v = {}, ctx = {}) => ({
        title: t('Open the record'),
        what: t('Icon of the record type next to a dimension of the node.'),
        why: t('Go to the product / warehouse card without searching.'),
        click: t('Click — open the record in a window on this page.'),
        affects: t('Opens a record widget; nothing changes here.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.bubble.rectSel': (v = {}, ctx = {}) => ({
        title: t('Selected area'),
        what: t('Dashed rectangle drawn with Shift+drag.'),
        why: t('Sum up a group of nodes.'),
        how: t('Nodes whose centres are inside get a dark outline; the legend window shows their totals and counts per class.'),
        affects: t('Nothing outside this chart.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        hotkey: t('Esc — clear'),
    }),
    'chart.bubble.hoverMarks': (v = {}, ctx = {}) => ({
        title: t('Node under the cursor'),
        what: t('Dashed ring around the bubble and its X / Y values at the axes.'),
        why: t('Shows which bubble the values belong to.'),
        how: t('Tags show the X and Y values of the ringed bubble (category names on category axes).'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "fe.ux.bubbleHoverTags",
    }),
    'chart.bubble.bars': (v = {}, ctx = {}) => ({
        title: t('Receipts / issues bars'),
        what: t('Two small bars on a bubble: green — receipts, red — issues.'),
        why: t('Compare flows of nodes without opening them.'),
        how: t('Bar height is relative to the largest receipt / issue in the chart.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "bubble_bars_in / _out / _mode / _height / _width / _in_color / _out_color",
    }),
    'chart.bubble.axisTitle': (v = {}, ctx = {}) => ({
        title: t('Axis names'),
        what: t('Names of the X and Y measures inside the plot.'),
        how: t('Italic label at the top-left = Y measure, at the bottom-right = X measure.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "bubble_x_title, bubble_y_title",
    }),
    'chart.bubble.yearTier': (v = {}, ctx = {}) => ({
        title: t('Years'),
        what: t('Second tier of the date axis with years.'),
        how: t('Each year label spans its months; vertical ticks mark year borders.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.bubble.configError': (v = {}, ctx = {}) => ({
        title: t('Not configured'),
        what: t('The bubble chart has no measures.'),
        how: t('Set the X, Y and Size fields in the widget settings.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
    }),

    // ---- map (31) ----
    'chart.map.legendBtn': (v = {}, ctx = {}) => ({
        title: t('Legend window'),
        what: t('Opens the map legend window: tab Node (values of what you hover) and tab Legend (colouring measure, layers, meaning of signs).'),
        why: t('All numbers in one place; the labels on the map stay short.'),
        click: t('Click — open / close. While it is open, hover labels on the map show only the name, checkbox and record icon.'),
        affects: t('Only this map.'),
        stored: t('Memory; not saved.'),
        setting: "fe.ux.geoMapCompactHover; fe.ux.legendFollowsOwner",
        states: { "on": t('The legend window is open'), "off": t('The legend window is closed') },
    }),
    'chart.map.cog': (v = {}, ctx = {}) => ({
        title: t('Map settings'),
        what: t('Settings of this map: measures, colours, points, links, ants, selectors.'),
        why: t('Change what the map shows and how.'),
        click: t('Click — open the settings window; click again — close it.'),
        affects: t('Only this map.'),
        stored: t('Settings are written to the widget (viewParams) and kept after you save it.'),
    }),
    'chart.map.legend.window': (v = {}, ctx = {}) => ({
        title: t('Map legend'),
        what: t('Free window of the map legend.'),
        why: t('Keeps numbers next to the map without covering it.'),
        click: t('Drag the header to move it; the window keeps its size while you hover different elements.'),
        affects: t('Hides on other tabs of the widget and closes with it.'),
        stored: t('Position — memory while the widget is open.'),
        setting: "fe.ux.legendStableSize",
    }),
    'chart.map.legend.close': (v = {}, ctx = {}) => ({
        title: t('Close the legend'),
        what: t('Closes the legend window.'),
        click: t('Click — close; hover labels on the map show their values again.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.map.legend.tabNode': (v = {}, ctx = {}) => ({
        title: t('Node tab'),
        what: t('Values of the last country, node or link you hovered.'),
        click: t('Click — switch the tab.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "node": t('Tab Node'), "legend": t('Tab Legend') },
    }),
    'chart.map.legend.tabLegend': (v = {}, ctx = {}) => ({
        title: t('Legend tab'),
        what: t('Measure that colours the countries, layer switches, meaning of circles and lines, selection.'),
        click: t('Click — switch the tab.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "node": t('Tab Node'), "legend": t('Tab Legend') },
    }),
    'chart.map.legend.nodeBlock': (v = {}, ctx = {}) => ({
        title: t('Values of what you hover'),
        what: t('Table of the last hovered country, node or link.'),
        why: t('Read stock, coverage and flows without labels covering the map.'),
        how: t('Red cell — an uncovered volume (> 0); pale red — expired stock; stock cover cell and pill are coloured by the stock state (same colours as in tables). Country — sum of its nodes, stock cover weighted, state = the worst. Values are for the player month, or for the whole period in Σ mode.'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "map_state_binding, map_state_end_binding, map_point_end_binding, map_expired_binding, map_in_binding, map_out_binding, map_dos_binding, map_dos_end_binding",
        states: { "node": t('Node'), "country": t('Country'), "link": t('Link between nodes'), "none": t('Hover an element of the map') },
    }),
    'chart.map.legend.measure': (v = {}, ctx = {}) => ({
        title: t('Measure of the colours'),
        what: t('Measures of the map; the ticked one colours the countries (a bar shows its colour scale).'),
        why: t('Look at the same map by another measure.'),
        click: t('Tick a measure — countries are recoloured by it; only one can be active. When stock cover is the active measure and the data has stock states, countries are coloured by the worst stock state instead of a gradient.'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        affects: t('Only this map; nothing is re-read.'),
        stored: t('Memory; the default measure comes from the map settings.'),
        setting: "map_value_binding (default measure)",
        states: { "on": t('Colours the countries'), "off": t('Not used for colours') },
    }),
    'chart.map.legend.show.links': (v = {}, ctx = {}) => ({
        title: t('Links'),
        what: t('Show the curved links (flows between nodes / countries).'),
        why: t('Declutter the map and look at one layer at a time.'),
        click: t('Click — show / hide the layer.'),
        affects: t('Only what this map draws; nothing is re-read.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "on": t('Shown'), "off": t('Hidden') },
    }),
    'chart.map.legend.show.nodes': (v = {}, ctx = {}) => ({
        title: t('Nodes'),
        what: t('Show circles of managed nodes (warehouses, distributors).'),
        why: t('Declutter the map and look at one layer at a time.'),
        click: t('Click — show / hide the layer.'),
        affects: t('Only what this map draws; nothing is re-read.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "on": t('Shown'), "off": t('Hidden') },
    }),
    'chart.map.legend.show.suppliers': (v = {}, ctx = {}) => ({
        title: t('Supply nodes'),
        what: t('Show circles of supplying nodes (suppliers).'),
        why: t('Declutter the map and look at one layer at a time.'),
        click: t('Click — show / hide the layer.'),
        affects: t('Only what this map draws; nothing is re-read.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "on": t('Shown'), "off": t('Hidden') },
    }),
    'chart.map.legend.show.countries': (v = {}, ctx = {}) => ({
        title: t('Country colouring'),
        what: t('Colour the countries by the active measure; off — countries are white.'),
        why: t('Declutter the map and look at one layer at a time.'),
        click: t('Click — show / hide the layer.'),
        affects: t('Only what this map draws; nothing is re-read.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "on": t('Shown'), "off": t('Hidden') },
    }),
    'chart.map.legend.footPoints': (v = {}, ctx = {}) => ({
        title: t('What circles mean'),
        what: t('Note: which measures give the size of a circle, its ring and its red core.'),
        how: t('Read it as the key for the circles on the map.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
    }),
    'chart.map.legend.footLinks': (v = {}, ctx = {}) => ({
        title: t('What links mean'),
        what: t('Note: link width = the link measure; red = its uncovered part.'),
        how: t('Blue line — covered flow; red line — the flow has an uncovered volume in this month / period.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
    }),
    'chart.map.legend.selected': (v = {}, ctx = {}) => ({
        title: t('Selection on the map'),
        what: t('How many countries and nodes are selected, and a link to clear them.'),
        click: t('Click «clear» — remove the map selection from the filter.'),
        affects: t('Widgets of the page that read these fields are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
    }),
    'chart.map.territory': (v = {}, ctx = {}) => ({
        title: t('How to read a country'),
        what: t('Fill of a country on the map.'),
        how: t('Gradient — the active measure: red = lowest, yellow = middle, green = highest (see the scale at the bottom). Coloured by stock state — the worst state of its nodes (OOS red, Low orange, Optimal yellow, OK light blue, High green). White with «–» — no movement in this month. Thick dark-blue border — the country is in the filter.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "map_value_binding, map_colors, map_color_min / max, map_single_color, map_color_empty, map_state_binding; fe.ux.geoMapSketch",
        states: { "scale": t('Coloured by the measure'), "state": t('Coloured by stock state'), "quiet": t('No movement this month'), "single": t('All values are equal — one colour'), "selected": t('In the filter') },
    }),
    'chart.map.countryLabel': (v = {}, ctx = {}) => ({
        title: t('Country label'),
        what: t('Flag and value of the country; on hover — its name, stock cover, stock state, sales and the uncovered part.'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        why: t('Read a country and put it into the filter with one click.'),
        click: t('Click the label — add / remove the country in the filter. Labels that do not fit are hidden until you hover the country.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        setting: "map_labels, map_selector_country; fe.ux.geomapLabelsHide, fe.ux.geoMapHoverExclusive, fe.ux.geoMapIsoFlags",
        states: { "selected": t('The country is in the filter'), "none": t('Not selected') },
    }),
    'chart.map.countryCheck': (v = {}, ctx = {}) => ({
        title: t('Country in the filter'),
        what: t('Checkbox: whether the country is in the workspace filter.'),
        click: t('Click — add / remove.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        states: { "on": t('In the filter'), "off": t('Not in the filter') },
    }),
    'chart.map.openRecord': (v = {}, ctx = {}) => ({
        title: t('Open the record'),
        what: t('Icon of the record type (country, warehouse, supplier…).'),
        why: t('Open the card of the element without searching.'),
        click: t('Click — open the record in a window on this page; the filter is not changed.'),
        affects: t('Opens a record widget.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.map.point': (v = {}, ctx = {}) => ({
        title: t('How to read a node'),
        what: t('Circles of a warehouse / distributor (node) or of a supplier.'),
        why: t('Stock, sales and uncovered demand of a node in one sign.'),
        how: t('Solid circle — stock at the end of the month / period, coloured by its stock state; dashed circle — stock at the start. White ring — sales (ring measure). Red core — uncovered volume. Supplier circle is blue, red if something it should ship is uncovered. Hollow dashed — no movement this month. Click a circle — put the node into the filter.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        setting: "map_point_binding, map_point_size_binding, map_point_ring_binding, map_point_core_binding, map_point_end_binding, map_state_binding, map_point_max, map_selector_node / map_selector_supplier",
    }),
    'chart.map.pointLabel': (v = {}, ctx = {}) => ({
        title: t('Node label'),
        what: t('Name of the node with its stock (start → end), stock cover and state; for a supplier — its volume and the uncovered part.'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        click: t('Click the label — add / remove the node in the filter. With the legend window open the label is short (values are in the Node tab).'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
    }),
    'chart.map.pointCheck': (v = {}, ctx = {}) => ({
        title: t('Node in the filter'),
        what: t('Checkbox: whether the node (or supplier) is in the workspace filter.'),
        click: t('Click — add / remove.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        setting: "map_selector_node, map_selector_supplier",
        states: { "on": t('In the filter'), "off": t('Not in the filter') },
    }),
    'chart.map.link': (v = {}, ctx = {}) => ({
        title: t('How to read a link'),
        what: t('Curve with an arrow from where goods come to where they go.'),
        why: t('Shows the supply routes and where supply fails.'),
        how: t('Thicker — bigger volume. Blue — covered flow; red with a red arrow — part of the flow is uncovered in this month / period. When you hover a node, its links stay bright and the rest fade. Hover a link to see its label and values.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "map_link_from_binding, map_link_to_binding, map_link_value_binding, map_link_uncovered_binding, map_link_color, map_link_avoid, map_hover_links",
        states: { "uncovered": t('Has an uncovered volume'), "covered": t('Covered') },
    }),
    'chart.map.linkLabel': (v = {}, ctx = {}) => ({
        title: t('Link label'),
        what: t('From → To of the link with the volume and the uncovered part.'),
        why: t('Pick either end of a flow for the filter.'),
        click: t('Use the checkbox of an end to filter by it, the icon to open its record.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
    }),
    'chart.map.linkEndCheck': (v = {}, ctx = {}) => ({
        title: t('End of the link in the filter'),
        what: t('Checkbox of one end of the link (supplier or receiving node).'),
        click: t('Click — add / remove it in the filter.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        states: { "on": t('In the filter'), "off": t('Not in the filter') },
    }),
    'chart.map.ants': (v = {}, ctx = {}) => ({
        title: t('Moving dots («ants»)'),
        what: t('Dots running along the links and spreading from nodes month by month.'),
        why: t('Shows when and how much goods move — the timing of the flows.'),
        how: t('More dots — bigger volume in the month. Blue on a link — covered flow; red — uncovered volume; green spreading from a node — its sales; red spreading — uncovered sales. The player (bottom-left) controls the month.'),
        affects: t('All flow widgets of the page move in one rhythm (shared player).'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "map_ants, map_ants_total, map_ants_date, map_ants_scatter_binding, map_ants_scatter_uncovered_binding",
    }),
    'chart.map.scaleLegend': (v = {}, ctx = {}) => ({
        title: t('Colour key'),
        what: t('Key of the country colours: measure name with min … max, or stock-state swatches.'),
        why: t('Translate a colour into a number or a state.'),
        how: t('Left end of the bar = lowest value, right end = highest. With stock states — each swatch is a state. In month view the scale is the same for all months, so months are comparable.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "map_legend, map_colors, map_color_min / max",
        states: { "scale": t('Gradient of the measure'), "state": t('Stock states'), "single": t('Single value') },
    }),
    'chart.map.zoomIn': (v = {}, ctx = {}) => ({
        title: t('Zoom in'),
        what: t('Zooms the map in by one step.'),
        click: t('Click — apply. The map re-places labels, circles and links.'),
        affects: t('Only the view of this map.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.map.zoomOut': (v = {}, ctx = {}) => ({
        title: t('Zoom out'),
        what: t('Zooms the map out by one step (not below the whole world).'),
        click: t('Click — apply. The map re-places labels, circles and links.'),
        affects: t('Only the view of this map.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.map.fit': (v = {}, ctx = {}) => ({
        title: t('Fit to view'),
        what: t('Fits the countries with data into the view, as at start.'),
        click: t('Click — apply. The map re-places labels, circles and links.'),
        affects: t('Only the view of this map.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "map_padding",
    }),
    'chart.map.empty': (v = {}, ctx = {}) => ({
        title: t('Nothing on the map'),
        what: t('Message instead of the map.'),
        how: t('«No data» — filters leave no rows; «No territories matched the data» — the country values of the data are not found on the map; «Map data is not available» — the world map failed to load.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),

    // ---- graph (46) ----
    'chart.graph.legendBtn': (v = {}, ctx = {}) => ({
        title: t('Legend window'),
        what: t('Opens the legend of the map view: tab Node (values of the hovered node, link or country area) and tab Legend (colouring measure, meaning of signs, selection).'),
        why: t('Read the numbers of the graph without tooltips covering it.'),
        click: t('Click — open / close.'),
        affects: t('Only this graph.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "viewParams.<graph>.graph_map; fe.ux.graphMapView",
        states: { "on": t('The legend window is open'), "off": t('The legend window is closed') },
    }),
    'chart.graph.cog': (v = {}, ctx = {}) => ({
        title: t('Graph settings'),
        what: t('Settings of the graph.'),
        why: t('Quick switches on hover, all settings on click.'),
        click: t('Hover — quick settings (layout, map view, ants, highlight…). Click — the settings window of the graph; click again — close it.'),
        affects: t('Only this graph; most quick switches re-read it.'),
        stored: t('Quick switches — widget record (doc.params) or widget settings (viewParams); see each switch.'),
        setting: "fe.ux.chartSettingsHoverMs; fe.ux.hoverHideMs",
        states: { "quick": t('Quick settings are shown') },
    }),
    // Odoo 348733: переключатель движка графа «Classic / Lens» (GraphEngineToggle.vue — островок графа DataHub; graph/lens/lensSwitch.js)
    'chart.graph.engine': (v = {}, ctx = {}) => ({
        title: t('Graph engine'),
        what: t('Switches how this graph is drawn: Classic — the platform graph; Lens — an overview of a large network (areas, rings, links, neighbourhood, legend filters).'),
        why: t('Thousands of models are easier to read in the Lens; the Classic graph keeps its own layout and settings.'),
        click: t('Click — switch the engine; the data are not read again.'),
        affects: t('Only this graph.'),
        stored: t('Remembered in this browser for this widget; also written to the widget settings (viewParams), so saving the widget makes it the default for everyone. The switch itself does not mark the widget as changed.'),
        setting: "viewParams.<graph>.graphEngine ('lens' | 'sigma'); localStorage graphEngine:<user>:<db>:<widget>:<graph>; database default fe.chart.graphEngineDefault (SETTINGS → Chart defaults)",   // Odoo 348733: + умолчание базы
        states: { "sigma": t('Classic engine'), "lens": t('Lens engine') },
    }),
    'chart.graph.stretchH': (v = {}, ctx = {}) => ({
        title: t('Stretch height'),
        what: t('Increases the vertical distance between rows of nodes (×1.15).'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_scale_y / graph_scale_x",
    }),
    'chart.graph.squeezeH': (v = {}, ctx = {}) => ({
        title: t('Squeeze height'),
        what: t('Decreases the vertical distance between rows of nodes.'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_scale_y / graph_scale_x",
    }),
    'chart.graph.stretchW': (v = {}, ctx = {}) => ({
        title: t('Stretch width'),
        what: t('Increases the distance between columns of nodes (×1.15).'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_scale_y / graph_scale_x",
    }),
    'chart.graph.squeezeW': (v = {}, ctx = {}) => ({
        title: t('Squeeze width'),
        what: t('Decreases the distance between columns of nodes.'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_scale_y / graph_scale_x",
    }),
    'chart.graph.fit': (v = {}, ctx = {}) => ({
        title: t('Fit to view'),
        what: t('Puts the whole graph into the widget.'),
        why: t('Return after zooming, stretching or scrolling.'),
        click: t('Click — the graph fits the widget; stretch factors and «keep spacing» switches are reset.'),
        affects: t('Only the view of this graph.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_scale_x / _y, graph_no_squeeze_x / _y",
    }),
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы, легенда скрыта): островок графа схемы v2 (AttrSchemeGraphV2) — те же кнопки, что у AttrGraph;
    // масштаб — viewParams без пометки записи, легенда видов — по умолчанию скрыта (память виджета)
    'chart.schemeGraph.legendBtn': (v = {}, ctx = {}) => ({
        title: t('Legend'),
        // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): кнопка прячет и подсказки над графом
        what: t('Shows or hides the legend of link kinds and the hints above the graph: the line and colour of each kind, what a click does, links to nodes outside the scheme.'),
        why: t('The legend and the hints are hidden by default to leave room for the graph.'),
        click: t('Click — show / hide the legend.'),
        affects: t('Only this graph.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "fe.ux.schemeGraphToolbar",
        states: { "on": t('The legend is open'), "off": t('The legend is closed') },
    }),
    'chart.schemeGraph.defaultLayout': (v = {}, ctx = {}) => ({
        title: t('Default layout'),
        what: t('Reset the nodes to the automatic layout and clear the saved one'),
        click: t('Click — the nodes return to the automatic layout; the record is marked as changed, Save keeps it.'),
        affects: t('Only this graph.'),
        stored: t('Graph layout field of the record (layout_binding): saved together with the record.'),
        setting: "params.layout_binding; fe.ux.schemeGraphToolbar",
    }),
    'chart.schemeGraph.stretchH': (v = {}, ctx = {}) => ({
        title: t('Stretch height'),
        what: t('Increases the vertical distance between rows of nodes (×1.15).'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_scale_y / graph_scale_x; fe.ux.schemeGraphToolbar",
    }),
    'chart.schemeGraph.squeezeH': (v = {}, ctx = {}) => ({
        title: t('Squeeze height'),
        what: t('Decreases the vertical distance between rows of nodes.'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_scale_y / graph_scale_x; fe.ux.schemeGraphToolbar",
    }),
    'chart.schemeGraph.stretchW': (v = {}, ctx = {}) => ({
        title: t('Stretch width'),
        what: t('Increases the distance between columns of nodes (×1.15).'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_scale_y / graph_scale_x; fe.ux.schemeGraphToolbar",
    }),
    'chart.schemeGraph.squeezeW': (v = {}, ctx = {}) => ({
        title: t('Squeeze width'),
        what: t('Decreases the distance between columns of nodes.'),
        why: t('Give dense parts of the graph more room, or bring it back into view.'),
        click: t('Click — one step. When the graph gets bigger than the widget, scroll bars appear. «Fit to view» returns it into the widget.'),
        affects: t('Only the layout of this graph on the screen.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_scale_y / graph_scale_x; fe.ux.schemeGraphToolbar",
    }),
    'chart.schemeGraph.fit': (v = {}, ctx = {}) => ({
        title: t('Fit to view'),
        what: t('Puts the whole graph into the widget.'),
        why: t('Return after zooming, stretching or scrolling.'),
        click: t('Click — the graph fits the width of the widget without scrolling; stretch factors are reset.'),
        affects: t('Only the view of this graph.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_scale_x / graph_scale_y; fe.ux.schemeGraphToolbar",
    }),
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: правка на графе схемы): кнопки правки островка графа схемы v2 — добавить узел / связь, откат / повтор
    'chart.schemeGraph.addNode': (v = {}, ctx = {}) => ({
        title: t('Add node'),
        what: t('Adds a node to the scheme: a new row of the nodes table with the title you type on the graph.'),
        click: t('Click, then click an empty place of the graph (inside a group frame — into that group) and type the title: Enter — add, Esc — cancel. The same — right-click on an empty place.'),
        affects: t('The nodes table and the graph layout of the record: the record is marked as changed, Save keeps it.'),
        stored: t('The record: saved with Save; the undo button of the graph takes the change back.'),
        setting: "params.editable, nodes_create_defaults; fe.ux.schemeGraphEdit",
        states: { "on": t('Click an empty place of the graph to put the node · Esc — cancel'), "off": t('Switched off') },
    }),
    'chart.schemeGraph.addLink': (v = {}, ctx = {}) => ({
        title: t('Add link'),
        what: t('Adds a link between two nodes: a new row of the links table with the default kind; the kind is changed later in the links table or the matrix.'),
        click: t('Click, then click the node the link starts from and the node it goes to: the line follows the pointer and sticks to the node under it. Esc — cancel. The same — right-click on a node.'),
        affects: t('The links table of the record: the record is marked as changed, Save keeps it.'),
        stored: t('The record: saved with Save; the undo button of the graph takes the change back.'),
        setting: "params.editable, edges_create_defaults; fe.ux.schemeGraphEdit",
    }),
    'chart.schemeGraph.undo': (v = {}, ctx = {}) => ({
        title: t('Undo'),
        what: t('Undo the last change on the graph'),
        click: t('Click, or Ctrl+Z with the pointer over the graph: the last added node or link is removed, a deleted link comes back.'),
        stored: t('Only while the record is open: after it is re-read the history of the graph is cleared.'),
        setting: "fe.ux.schemeGraphEdit",
    }),
    'chart.schemeGraph.redo': (v = {}, ctx = {}) => ({
        title: t('Redo'),
        what: t('Redo the change on the graph'),
        click: t('Click, or Ctrl+Y with the pointer over the graph.'),
        stored: t('Only while the record is open: after it is re-read the history of the graph is cleared.'),
        setting: "fe.ux.schemeGraphEdit",
    }),
    // IE 2026 10 25 / ODOO-348925 (заказ Игоря: тулбар AttrGraph на графе схемы — поиск, настройки, dragDrop): поиск сверху, шестерёнка и её флажки графа схемы v2 — те же места
    // и подписи, что у AttrGraph (chart.graph.cog / chart.graph.qs.*); хранение другое — viewParams без пометки записи, ничего не перечитывается — поэтому свои объяснения
    'chart.schemeGraph.search': (v = {}, ctx = {}) => ({
        title: t('Search'),
        what: t('Searches the nodes of the graph by title and key: found nodes get an orange frame, the matched part of the title is bold, the rest fade.'),
        why: t('Find a plan in a big scheme without looking through all columns.'),
        click: t('Type — the nodes are highlighted at once; Enter — a search chip and a jump to the first found node; Enter in the empty field or the arrows of the chip — the next found node (the graph scrolls to it). Remove the chip — everything comes back. The selection in the tables does not change.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Search chips of the graph (viewParams) — like the chips of a table.'),
        setting: "viewParams.<graph>.CHIPS / hideCHIPS; fe.ux.schemeGraphToolbar",
    }),
    'chart.schemeGraph.cog': (v = {}, ctx = {}) => ({
        title: t('Graph settings'),
        what: t('Settings of the graph.'),
        why: t('Quick switches of the scheme graph: arrows, switched-off nodes, highlight on hover, layout.'),
        click: t('Hover or click — quick switches; click again — close them.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_edge_arrows / graph_hide_unused / graph_hover_neighbors / layout_mode / node_view; fe.ux.chartSettingsHoverMs; fe.ux.hoverHideMs; fe.ux.schemeGraphToolbar",
        states: { "quick": t('Quick settings are shown') },
    }),
    'chart.schemeGraph.qs.graph_edge_arrows': (v = {}, ctx = {}) => ({
        title: t('Edge arrows'),
        what: t('Arrows at the ends of links show their direction (on by default).'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_edge_arrows",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.schemeGraph.qs.graph_hide_unused': (v = {}, ctx = {}) => ({
        title: t('Hide unused (use = false)'),
        what: t('Hides switched-off nodes and links (use = false) and lays out the rest (off by default).'),
        why: t('See only the working part of the scheme.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_hide_unused",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.schemeGraph.qs.graph_hover_neighbors': (v = {}, ctx = {}) => ({
        title: t('Highlight neighbours'),
        what: t('Hovering a node highlights it, its linked nodes and links; the rest fade (on by default).'),
        why: t('Follow one chain of plans in a dense scheme.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.graph_hover_neighbors",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.schemeGraph.qs.layout_mode': (v = {}, ctx = {}) => ({
        title: t('Node layout'),
        what: t('Columns of groups — each group of the scheme is a column, its nodes in the order of rows; Layers — automatic layout along the links.'),
        why: t('Look at the scheme the other way without changing it.'),
        click: t('Click — choose.'),
        affects: t('Only this graph on the screen; the layout of the scheme set by the server is not changed.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.layout_mode (over params.layout_mode)",
    }),
    // IE 2026 10 26 / ODOO-5800 (слово Igor 26.10 через ie-dm7 #106105: граф схемы — наконечники, ⚑ прячет подсказки, высота, вид узлов): вид узлов графа схемы (⚙): Прямокутники / Картки (cascade — резерв)
    'chart.schemeGraph.qs.node_view': (v = {}, ctx = {}) => ({
        title: t('Node view'),
        what: t('Boxes — a rectangle with the node title; Cards — the card of the ERD tab: title, node kind, horizon pills and the fields of the node with their role.'),
        why: t('See which fields each node carries right on the graph of links.'),
        click: t('Click — choose.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget settings (viewParams): kept with the next save of the record; the button itself does not mark it as changed.'),
        setting: "viewParams.<graph>.node_view (over params.node_view, params.node_views); fe.ux.schemeGraphNodeView",
    }),
    'chart.graph.qs.graph_map': (v = {}, ctx = {}) => ({
        title: t('Map view'),
        what: t('The graph is drawn by the rules of the Flow Map: country areas, node colour and size by measures, link width by volume, red for uncovered (off by default).'),
        why: t('See where stock and flows are in trouble right on the supply-rule graph.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<graph>.graph_map; fe.ux.graphMapView",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_areas': (v = {}, ctx = {}) => ({
        title: t('Country areas'),
        what: t('In the map view, bands of nodes of one country are filled as areas coloured by the measure of the country (on by default).'),
        why: t('Compare countries at a glance, like on the map.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<graph>.graph_areas",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_ants': (v = {}, ctx = {}) => ({
        title: t('Ants along the links'),
        what: t('Moving dots run along the links of the graph in the rhythm of the page player (off by default).'),
        why: t('Show the direction of supply; dots move together with the map and flow widgets of the page.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_ants",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_ants_total': (v = {}, ctx = {}) => ({
        title: t('Start with totals (Σ)'),
        what: t('The page player starts in Σ mode — totals of the whole period, paused — instead of playing month by month (on by default).'),
        why: t('Open the page on the overall picture first.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_ants_total",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs._rectSelect': (v = {}, ctx = {}) => ({
        title: t('Rectangle select'),
        what: t('Mode: dragging on an empty area selects the nodes inside a frame; with Shift the nodes are added to the selection (off by default).'),
        why: t('Select many nodes at once (the same as clicking them one by one). Shift+drag works even without the mode.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "(local, not saved)",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_hover_neighbors': (v = {}, ctx = {}) => ({
        title: t('Highlight neighbours'),
        what: t('Hovering a node highlights it, its linked nodes and links; the rest fade (on by default).'),
        why: t('Follow one supply chain in a dense graph.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_hover_neighbors",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_edge_arrows': (v = {}, ctx = {}) => ({
        title: t('Edge arrows'),
        what: t('Arrows at the ends of links show the direction of supply (on by default).'),
        why: t('Read where goods go.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_edge_arrows",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_route_columns': (v = {}, ctx = {}) => ({
        title: t('Route columns'),
        what: t('Nodes are placed in columns by their step in the supply chain (suppliers → warehouses → work centres → …) with column captions (on by default).'),
        why: t('The chain reads left to right; off — columns by node role.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_route_columns",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_minimize_crossings': (v = {}, ctx = {}) => ({
        title: t('Minimize crossings'),
        what: t('Nodes are reordered inside their column and country band so that links cross less (on by default).'),
        why: t('A cleaner picture of dense graphs.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_minimize_crossings",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_flat_list': (v = {}, ctx = {}) => ({
        title: t('Flat list (data tab)'),
        what: t('The data tab of the graph shows the rules as a flat list; off — as a nested tree (on by default).'),
        why: t('A flat list is easier to filter and sort.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_flat_list",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_unique_nodes': (v = {}, ctx = {}) => ({
        title: t('Unique nodes'),
        what: t('Each subject is drawn once, even if it appears on several steps of the chain (off by default).'),
        why: t('Fewer nodes; off — a warehouse may repeat in several columns (echelons).'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_unique_nodes",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_hide_unused': (v = {}, ctx = {}) => ({
        title: t('Hide unused rules'),
        what: t('Rules that are not in use (use = false) are not drawn (off by default).'),
        why: t('See only the rules that act.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_hide_unused",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_avoid_horizontal': (v = {}, ctx = {}) => ({
        title: t('Avoid horizontal links (snake)'),
        what: t('Nodes are shifted slightly so that links of one row do not merge into one horizontal line (on by default).'),
        why: t('Each link stays visible.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_avoid_horizontal",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_avoid_vertical': (v = {}, ctx = {}) => ({
        title: t('Avoid vertical links (snake)'),
        what: t('The same shift for links that would merge vertically (off by default).'),
        why: t('Each link stays visible.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_avoid_vertical",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_chain_step': (v = {}, ctx = {}) => ({
        title: t('Expand chain +1 step'),
        what: t('Adds one step of the bill of materials both ways: materials of the shown products and products made of the shown materials (added nodes are faded) (off by default).'),
        why: t('See what the selection depends on and what it feeds.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_chain_step",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_chain_all': (v = {}, ctx = {}) => ({
        title: t('Expand chain (all steps)'),
        what: t('Adds bill-of-materials steps until the whole chain is shown (off by default).'),
        why: t('The complete chain of the selection.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_chain_all",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_nudge_off_links': (v = {}, ctx = {}) => ({
        title: t('Move nodes off crossing links'),
        what: t('Nodes whose labels are crossed by links are moved aside (on by default).'),
        why: t('Labels stay readable.'),
        click: t('Click — on / off.'),
        affects: t('Only this graph on the screen; nothing is re-read.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_nudge_off_links",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_no_squeeze_y': (v = {}, ctx = {}) => ({
        title: t('Keep vertical spacing (scroll)'),
        what: t('Rows of nodes keep a minimum distance; if they do not fit, a vertical scroll bar appears. «auto» — switched on by itself because nodes overlapped (off by default).'),
        why: t('Readable labels instead of a graph squeezed into the widget.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_no_squeeze_y; fe.chart.graphMinStepPx",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_no_squeeze_x': (v = {}, ctx = {}) => ({
        title: t('Keep horizontal spacing (scroll)'),
        what: t('Columns keep a minimum distance; if they do not fit, a horizontal scroll bar appears (off by default).'),
        why: t('Readable columns of a long chain.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_no_squeeze_x",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.graph_engine_std': (v = {}, ctx = {}) => ({
        title: t('Standard layout (Sugiyama)'),
        what: t('Layout is computed in the browser by the standard layered method, node size includes its label; off — positions from the server (off by default).'),
        why: t('An alternative layout when the server one is too dense.'),
        click: t('Click — on / off.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_engine_std",
        states: { "on": t('Switched on'), "off": t('Switched off') },
    }),
    'chart.graph.qs.custom': (v = {}, ctx = {}) => ({
        title: t('Options of this graph'),
        what: t('Extra switches defined for this particular graph by its configuration.'),
        click: t('Click — switch (or pick one value of a list); the graph is re-read.'),
        affects: t('The graph is re-read with the new option.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "attr.graphOptions → doc.params.<key>",
    }),
    'chart.graph.legend.window': (v = {}, ctx = {}) => ({
        title: t('Graph legend'),
        what: t('Free window with the legend of the map view of the graph.'),
        click: t('Drag the header to move it; it keeps its size while you hover.'),
        affects: t('Hides on other tabs of the widget and closes with it.'),
        stored: t('Position — memory while the widget is open.'),
    }),
    'chart.graph.legend.close': (v = {}, ctx = {}) => ({
        title: t('Close the legend'),
        what: t('Closes the legend window.'),
        click: t('Click — close.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.graph.legend.tabNode': (v = {}, ctx = {}) => ({
        title: t('Node tab'),
        what: t('Values of the last hovered node, link or country area (active measure in bold).'),
        click: t('Click — switch the tab.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "node": t('Tab Node'), "legend": t('Tab Legend') },
    }),
    'chart.graph.legend.tabLegend': (v = {}, ctx = {}) => ({
        title: t('Legend tab'),
        what: t('Colouring measure, meaning of areas, circles and links, selection.'),
        click: t('Click — switch the tab.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "node": t('Tab Node'), "legend": t('Tab Legend') },
    }),
    'chart.graph.legend.nodeBlock': (v = {}, ctx = {}) => ({
        title: t('Values of what you hover'),
        what: t('Measures of the hovered node, link or country area.'),
        how: t('Bold row — the measure that colours the graph; red value — uncovered volume. A country area sums its nodes (stock cover and similar are averaged).'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "node": t('Node'), "edge": t('Link between nodes'), "area": t('Country area'), "none": t('Hover an element') },
    }),
    'chart.graph.legend.measure': (v = {}, ctx = {}) => ({
        title: t('Measure of the colours'),
        what: t('Numeric measures of the nodes; the ticked one colours nodes and country areas.'),
        why: t('Look at the graph by another measure.'),
        click: t('Tick a measure — nodes and areas are recoloured (red — lowest, yellow — middle, green — highest).'),
        affects: t('Only this graph.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<graph>.graph_value_binding",
        states: { "on": t('Colours the graph'), "off": t('Not used for colours') },
    }),
    'chart.graph.legend.feet': (v = {}, ctx = {}) => ({
        title: t('Key of the signs'),
        what: t('Which measure gives the fill of areas and nodes, the circle size, the ring, the red core and the link width.'),
        how: t('Read it as the key for the graph: ring — second measure, red core and red links — uncovered volume.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "viewParams.<graph>.graph_point_size_binding / graph_point_ring_binding / graph_point_core_binding / graph_link_value_binding / graph_link_unc_binding",
    }),
    'chart.graph.legend.selected': (v = {}, ctx = {}) => ({
        title: t('Selection on the graph'),
        what: t('How many nodes and countries are selected, and a link to clear them.'),
        click: t('Click «clear» — remove them from the filter.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
    }),
    'chart.graph.area': (v = {}, ctx = {}) => ({
        title: t('How to read a country area'),
        what: t('Tinted band behind the nodes of one country.'),
        why: t('Compare countries like on the map.'),
        how: t('Colour = the active measure summed over the country nodes (stock cover and similar measures averaged): red — lowest, green — highest. Title shows the country and its value. Hover the title to select the country.'), // IE 2026 09 25 / ODOO-5800: DOS → stock cover (Igor 25.09)
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "viewParams.<graph>.graph_areas; fe.chart.graphAreaLabelPadPx",
    }),
    'chart.graph.node': (v = {}, ctx = {}) => ({
        title: t('How to read a node'),
        what: t('Circle of a subject in the map view of the graph.'),
        how: t('Fill — the active measure (red — lowest, green — highest, grey — no value); size — the size measure (stock); hollow — no volume; dark ring — second measure (e.g. outflow); red core — uncovered volume.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "viewParams.<graph>.graph_value_binding, graph_point_size_binding, graph_point_ring_binding, graph_point_core_binding",
    }),
    'chart.graph.edge': (v = {}, ctx = {}) => ({
        title: t('How to read a link'),
        what: t('Line between two subjects of the graph.'),
        how: t('Thicker — bigger volume of the link measure; red — the link has an uncovered volume (drawn on top).'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "viewParams.<graph>.graph_link_value_binding, graph_link_unc_binding",
    }),
    'chart.graph.badge.check': (v = {}, ctx = {}) => ({
        title: t('Node in the filter'),
        what: t('Checkbox in the badge of the hovered node or country area.'),
        why: t('Filter the page by a subject straight from the graph.'),
        click: t('Click — add / remove it in the workspace filter.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        states: { "on": t('In the filter'), "off": t('Not in the filter') },
    }),
    'chart.graph.badge.open': (v = {}, ctx = {}) => ({
        title: t('Open the record'),
        what: t('Icon of the record type of the node.'),
        click: t('Click — open its record on this page; the filter is not changed.'),
        affects: t('Opens a record widget.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.graph.badge.countryCheck': (v = {}, ctx = {}) => ({
        title: t('Country of the node in the filter'),
        what: t('Second checkbox in the badge: the country of this node.'),
        click: t('Click — add / remove the country in the workspace filter.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        setting: "fe.ux.graphCountryFlags",
        states: { "on": t('In the filter'), "off": t('Not in the filter') },
    }),
    'chart.graph.ants': (v = {}, ctx = {}) => ({
        title: t('Moving dots on links'),
        what: t('Dots running along the links from supplier to receiver.'),
        why: t('Shows the direction of supply and keeps the rhythm with the map and flow widgets of the page.'),
        how: t('More dots — thicker link. Colour — the colour of the link. The graph has no months of its own: a batch starts on each month of the page player.'),
        affects: t('Shares the page player.'),
        stored: t('Widget record parameters (doc.params): saved together with the widget; the switch itself does not mark it as changed.'),
        setting: "doc.params.graph_ants, graph_ants_total",
    }),
    'chart.graph.serverLegend': (v = {}, ctx = {}) => ({
        title: t('Graph key'),
        what: t('Key of node colours and link markers of this graph.'),
        how: t('Each row: a colour or a marker and what it means.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
    }),
    'chart.graph.linksPanel': (v = {}, ctx = {}) => ({
        title: t('Links of the node'),
        what: t('Panel with what the clicked node uses and what uses it.'),
        why: t('Walk the dependencies of configuration objects.'),
        click: t('Click a row — open the panel of that node; «Open list» — the list of its segment; × — close.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.graph.rectSel': (v = {}, ctx = {}) => ({
        title: t('Selection frame'),
        what: t('Frame you draw to select nodes.'),
        click: t('Nodes inside are selected on release; with Shift they are added to the current selection.'),
        affects: t('The same as clicking the nodes: highlight and selectors of the page follow.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        hotkey: t('Shift+drag — add to the selection'),
    }),

    // ---- flow (16) ----
    'chart.flow.legendBtn': (v = {}, ctx = {}) => ({
        title: t('Legend window'),
        what: t('Opens the legend of the flow canvas: tab Node (hovered supplier, hub, country or flow) and tab Legend (what disks, rings and widths mean).'),
        why: t('Numbers of the flows without a card covering the canvas.'),
        click: t('Click — open / close.'),
        affects: t('Only this widget.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "on": t('The legend window is open'), "off": t('The legend window is closed') },
    }),
    'chart.flow.legend.window': (v = {}, ctx = {}) => ({
        title: t('Flow legend'),
        what: t('Free window of the flow legend.'),
        click: t('Drag the header to move it.'),
        affects: t('Hides on other tabs of the widget and closes with it.'),
        stored: t('Position — memory while the widget is open.'),
    }),
    'chart.flow.legend.close': (v = {}, ctx = {}) => ({
        title: t('Close the legend'),
        what: t('Closes the legend window.'),
        click: t('Click — close; the hover card on the canvas comes back.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.flow.legend.tabNode': (v = {}, ctx = {}) => ({
        title: t('Node tab'),
        what: t('Values of the last hovered supplier, hub, country or flow: volume of the period and of the month, top flows.'),
        click: t('Click — switch the tab.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "node": t('Tab Node'), "legend": t('Tab Legend') },
    }),
    'chart.flow.legend.tabLegend': (v = {}, ctx = {}) => ({
        title: t('Legend tab'),
        what: t('Meaning of the disk, ring, red core and flow width; selection.'),
        click: t('Click — switch the tab.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "node": t('Tab Node'), "legend": t('Tab Legend') },
    }),
    'chart.flow.legend.nodeBlock': (v = {}, ctx = {}) => ({
        title: t('Values of what you hover'),
        what: t('Numbers of the hovered supplier, hub, country or flow.'),
        how: t('Month values follow the page player; in Σ mode — totals of the period (stock is the average). Red value — uncovered sales.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "supplier": t('Supplier'), "hub": t('Hub'), "country": t('Country'), "flow": t('Flow'), "none": t('Hover an element') },
    }),
    'chart.flow.legend.feet': (v = {}, ctx = {}) => ({
        title: t('Key of the signs'),
        what: t('What the disk, the ring, the red core and the width of a flow mean.'),
        how: t('Blue disk — stock of the country / hub; white ring — its sales; red core — uncovered sales; a thicker flow — bigger volume of the period; more dots — bigger volume of the month.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "attr.ant_stock_measure / ant_sales_measure / ant_uncovered_measure",
    }),
    'chart.flow.legend.selected': (v = {}, ctx = {}) => ({
        title: t('Selection'),
        what: t('How many suppliers and countries are selected, and «clear».'),
        click: t('Click «clear» — remove them from the filter.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
    }),
    'chart.flow.canvas': (v = {}, ctx = {}) => ({
        title: t('Flows of goods'),
        what: t('Picture of supply: suppliers on the left, the hub (receiving warehouses) in the middle, countries on the right, curves between them.'),
        why: t('See who supplies which countries and how much, month by month.'),
        how: t('Thicker curve — bigger volume of the period; moving dots — volume of the current month of the player. Hover a supplier, the hub, a country or a curve to see its numbers.'),
        affects: t('The page player moves all flow widgets of the page together.'),
        stored: t('Defined by the widget configuration; nothing changes here.'),
        setting: "attr.ant_from / ant_via / ant_to / ant_date / ant_qty / ant_measure",
    }),
    'chart.flow.countryGlyph': (v = {}, ctx = {}) => ({
        title: t('How to read a country'),
        what: t('Circles of a country (and of the hub): stock, sales and uncovered sales.'),
        how: t('Light-blue disk — stock in the month; white ring — sales (covered + uncovered); red core — uncovered sales. Bigger — more. In Σ mode — the whole period (stock is the average).'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.flow.supplier': (v = {}, ctx = {}) => ({
        title: t('Supplier'),
        what: t('Circle of a supplier in its own colour.'),
        how: t('Bigger — more volume of the period. Its flows and dots have the same colour. Hover — its numbers; checkbox in the badge — filter by it.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.flow.ants': (v = {}, ctx = {}) => ({
        title: t('Dots of the month'),
        what: t('Dots running along the curves.'),
        why: t('Show the timing of the flows.'),
        how: t('Each batch of dots = volume of one month of the player; more dots — more volume. When the page period is one month and paused, the dots stop halfway.'),
        affects: t('Shared page player.'),
        stored: t('Shared player of the page (memory); nothing is saved.'),
    }),
    'chart.flow.tip': (v = {}, ctx = {}) => ({
        title: t('Hover card'),
        what: t('Short card with the numbers of the element under the cursor.'),
        how: t('Open the legend window to see the same numbers in the Node tab instead.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.flow.badge.check': (v = {}, ctx = {}) => ({
        title: t('Filter by this supplier / country'),
        what: t('Checkbox in the badge of the hovered supplier or country.'),
        click: t('Click — add / remove it in the workspace filter.'),
        affects: t('Adds / removes the value in the workspace filter chip; widgets of the page that read this field are re-read.'),
        stored: t('Workspace filter chip (session); kept in this browser for this workspace, not written to the workspace record.'),
        hotkey: t('Alt+click — keep only this value in the chip'),
        states: { "on": t('In the filter'), "off": t('Not in the filter') },
    }),
    'chart.flow.badge.open': (v = {}, ctx = {}) => ({
        title: t('Open the record'),
        what: t('Icon of the record type.'),
        click: t('Click — open the record of the supplier / country on this page.'),
        affects: t('Opens a record widget.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.flow.empty': (v = {}, ctx = {}) => ({
        title: t('No flows'),
        what: t('There are no flows for the current chips and period.'),
        how: t('Change the chips or the period.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),

    // ---- player (8) ----
    'chart.player.island': (v = {}, ctx = {}) => ({
        title: t('Month player'),
        what: t('Player of the flows by month: totals Σ, play / pause, restart, speed, month and a month slider.'),
        why: t('Watch how stock and flows change month by month, or see the totals of the whole period.'),
        how: t('Hover the island to unfold it. The months come from all flow widgets of the page and are limited by the workspace period chip.'),
        affects: t('The player is shared by all flow widgets of the page (map ants, graph ants, flow canvas): they all show the same month.'),
        stored: t('Shared player of the page (memory); nothing is saved.'),
        setting: "fe.ux.antPlayerCollapse; map_ants_total / graph_ants_total / ant_total_start",
        states: { "total": t('Whole period (Σ), paused'), "playing": t('Playing month by month'), "paused": t('Paused on a month') },
    }),
    'chart.player.total': (v = {}, ctx = {}) => ({
        title: t('Whole period (Σ)'),
        what: t('Switches the page between totals of the whole period and values of one month.'),
        why: t('Start from the overall picture, then look at months.'),
        click: t('On (dark button) — maps and the flow canvas show totals of all months, the player is paused (dots already on their way finish it), the month slider is hidden. Click again or Play — back to months and playing.'),
        affects: t('The player is shared by all flow widgets of the page (map ants, graph ants, flow canvas): they all show the same month.'),
        stored: t('Shared player of the page (memory); nothing is saved.'),
        states: { "on": t('Totals of the whole period'), "off": t('Values of the month') },
    }),
    'chart.player.play': (v = {}, ctx = {}) => ({
        title: t('Play / pause'),
        what: t('Starts or stops moving through the months.'),
        click: t('Click — play / pause. In Σ mode — back to month values and play. If the page period is one month, pause shows the dots stopped halfway (a snapshot).'),
        affects: t('The player is shared by all flow widgets of the page (map ants, graph ants, flow canvas): they all show the same month.'),
        stored: t('Shared player of the page (memory); nothing is saved.'),
        states: { "playing": t('Playing'), "paused": t('Paused'), "total": t('Σ — paused on totals') },
    }),
    'chart.player.restart': (v = {}, ctx = {}) => ({
        title: t('Restart'),
        what: t('Goes back to the first month and plays.'),
        click: t('Click — start from the first month (Σ is switched off).'),
        affects: t('The player is shared by all flow widgets of the page (map ants, graph ants, flow canvas): they all show the same month.'),
        stored: t('Shared player of the page (memory); nothing is saved.'),
    }),
    'chart.player.speed': (v = {}, ctx = {}) => ({
        title: t('Speed'),
        what: t('How fast months change: ×1, ×2, ×4.'),
        click: t('Click — next speed (after ×4 back to ×1). At ×1 a month lasts about 1.4 s.'),
        affects: t('The player is shared by all flow widgets of the page (map ants, graph ants, flow canvas): they all show the same month.'),
        stored: t('Shared player of the page (memory); nothing is saved.'),
        states: { "1": t('Speed ×1'), "2": t('Speed ×2'), "4": t('Speed ×4') },
    }),
    'chart.player.month': (v = {}, ctx = {}) => ({
        title: t('Month'),
        what: t('Month shown by all flow widgets of the page, or the bounds of the period in Σ mode.'),
        how: t('«all» — the data has no dates; the dots start on every month of the player.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.player.stats': (v = {}, ctx = {}) => ({
        title: t('Volumes'),
        what: t('Volumes of the current month (or of the period in Σ) of this widget.'),
        how: t('in — incoming flows, sales — sales, uncovered — the part that cannot be covered; «edges N» on a graph — number of links with dots.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.player.range': (v = {}, ctx = {}) => ({
        title: t('Choose a month'),
        what: t('Slider over all months of the page.'),
        click: t('Drag — jump to a month; all flow widgets of the page follow.'),
        affects: t('The player is shared by all flow widgets of the page (map ants, graph ants, flow canvas): they all show the same month.'),
        stored: t('Shared player of the page (memory); nothing is saved.'),
    }),

    // ---- treemap (6) ----
    'chart.treemap.legendBtn': (v = {}, ctx = {}) => ({
        title: t('Legend'),
        what: t('Opens the TreeMap legend: which measure gives the size of the tiles and which dimensions nest them.'),
        why: t('Change what the tiles show without the settings window.'),
        click: t('Click — open / close.'),
        affects: t('Only this widget.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "fe.ux.treemapLegend",
        states: { "on": t('The legend is open'), "off": t('The legend is closed') },
    }),
    'chart.treemap.cog': (v = {}, ctx = {}) => ({
        title: t('TreeMap settings'),
        what: t('Settings of this TreeMap.'),
        click: t('Click — open the settings window; click again — close it.'),
        affects: t('Only this widget.'),
        stored: t('Settings are written to the widget (viewParams) and kept after you save it.'),
    }),
    'chart.treemap.legend.close': (v = {}, ctx = {}) => ({
        title: t('Close the legend'),
        what: t('Closes the legend panel.'),
        click: t('Click — close.'),
        stored: t('Only in this view (memory); nothing is saved.'),
    }),
    'chart.treemap.legend.measure': (v = {}, ctx = {}) => ({
        title: t('Size of the tiles'),
        what: t('Numeric fields; the ticked one gives the size of the tiles.'),
        click: t('Tick a field — tiles are redrawn by it. One field is always active.'),
        affects: t('Only this widget; nothing is re-read.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<treemap>.tree_binding",
        states: { "on": t('Gives the tile size'), "off": t('Not used') },
    }),
    'chart.treemap.legend.dimension': (v = {}, ctx = {}) => ({
        title: t('Nesting levels'),
        what: t('Dimensions that group the tiles; the number is the level (1 — outer).'),
        why: t('Group tiles by country, then by product, etc.'),
        click: t('Tick — add the dimension as the next level; untick — remove it (at least one stays).'),
        affects: t('Only this widget; nothing is re-read.'),
        stored: t('Widget settings (viewParams): the widget is marked as changed and keeps the value after you save it.'),
        setting: "viewParams.<treemap>.tree_dimension",
    }),
    'chart.treemap.tiles': (v = {}, ctx = {}) => ({
        title: t('How to read tiles'),
        what: t('Rectangles whose area is the value of the measure, nested by the chosen dimensions.'),
        why: t('See the share of each group at a glance.'),
        how: t('Bigger tile — bigger value; tiles of one group sit together inside its frame. Colours only separate groups.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "attr.attr_typeTreeMap",
    }),

    // ---- gantt (14) ----
    'chart.gantt.cog': (v = {}, ctx = {}) => ({
        title: t('Gantt settings'),
        what: t('Settings of the movements Gantt: grouping of rows, month width, fact stock layer.'),
        click: t('Click — open the settings window; click again — close it.'),
        affects: t('Only this widget.'),
        stored: t('Settings are written to the widget (viewParams) and kept after you save it.'),
        setting: "attr.gantt_group_by, gantt_month_width, gantt_node_binding, gantt_fact_stock",
    }),
    'chart.gantt.count': (v = {}, ctx = {}) => ({
        title: t('How much is shown'),
        what: t('Number of nodes and movements in the Gantt for the current filters.'),
        how: t('Movement = one document in one month of one layer.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.gantt.months': (v = {}, ctx = {}) => ({
        title: t('Months'),
        what: t('Time axis of the Gantt: one column per month.'),
        how: t('Bold with a year — start of a year; purple — the month of the fact stock date of the workspace; stripes alternate for readability.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "attr.gantt_month_width",
    }),
    'chart.gantt.factDate': (v = {}, ctx = {}) => ({
        title: t('Fact stock date'),
        what: t('Plan start capsule with the flag at the fact stock date of the workspace: {date}.', { date: v.date || '' }),   // IE 2026 09 30 / ODOO-343343 (заказ Игоря: элемент Plan start одинаковый во всех формах): капсула вместо линии и пилюли; vars.date — дата факта
        why: t('Separates what already happened from the plan.'),
        how: t('Left of the capsule — fact, right — planned movements. The fact stock layer starts here.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "workspace params.date_fact_stock",
    }),
    'chart.gantt.nodeRow': (v = {}, ctx = {}) => ({
        title: t('Group of rows'),
        what: t('Row of a grouping level (e.g. country, then subject); the pill shows how many movements it contains.'),
        why: t('Fold what you do not need and compare groups.'),
        click: t('Click the row — fold / unfold it. Leaves of the tree hold the layers of a node.'),
        affects: t('Only this view.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        setting: "attr.gantt_group_by",
        states: { "open": t('Unfolded'), "folded": t('Folded') },
    }),
    'chart.gantt.collapse': (v = {}, ctx = {}) => ({
        title: t('Fold / unfold'),
        what: t('Minus / plus icon of a grouping row.'),
        click: t('Click — fold / unfold the group.'),
        stored: t('Only in this view (memory); nothing is saved.'),
        states: { "open": t('Unfolded'), "folded": t('Folded') },
    }),
    'chart.gantt.guides': (v = {}, ctx = {}) => ({
        title: t('Tree lines'),
        what: t('Thin lines that connect rows to their parent group.'),
        how: t('A corner marks the last row of a group.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.gantt.groupHead': (v = {}, ctx = {}) => ({
        title: t('Side'),
        what: t('Small header: layers below are receipts (+) or shipments (−).'),
        how: t('Receipts come first, then shipments; the fact stock layer is on top.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.gantt.laneTitle': (v = {}, ctx = {}) => ({
        title: t('Layer'),
        what: t('Type of movement shown in this line.'),
        how: t('A red «Uncovered» pill — the layer holds the part of that movement that cannot be covered.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.gantt.item': (v = {}, ctx = {}) => ({
        title: t('Movement'),
        what: t('Bar of one document (order, transfer, sale…) in one month of a layer; the number is its quantity.'),
        why: t('See when and how much moves and which receipt covers which shipment.'),
        click: t('Hover — related movements are highlighted, the rest fade. Click — open the document. Hold Alt (or turn on Show tooltips) to see its card: quantity, dates order → shipment → arrival, partner.'),
        affects: t('Opens a record widget; nothing is changed.'),
        stored: t('Nothing is stored — it only shows the data.'),
        hotkey: t('Alt — card of the movement'),
        setting: "fe.ux.ganttTipGate",
    }),
    'chart.gantt.colours': (v = {}, ctx = {}) => ({
        title: t('How to read colours'),
        what: t('Colour code of the movement layers.'),
        how: t('Violet — purchase orders; teal — Ex-Delta and transfers; blue — sales; brown — production; red — destruction or an uncovered part (dashed border); amber — consignment; grey-green — fact stock. Darker bar — bigger quantity within its layer.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
    'chart.gantt.stockBar': (v = {}, ctx = {}) => ({
        title: t('Fact stock'),
        what: t('Bar of the actual stock of the node: from the fact date to the date it lasts.'),
        why: t('Compare stock coverage with the planned shipments.'),
        how: t('Length — how long the stock lasts; the number — quantity. It lights up when you hover a shipment of the same node.'),
        stored: t('Nothing is stored — it only shows the data.'),
        hotkey: t('Alt — card'),
        setting: "attr.gantt_fact_stock",
    }),
    'chart.gantt.tip': (v = {}, ctx = {}) => ({
        title: t('Movement card'),
        what: t('Dark card with the details of the bar under the cursor.'),
        how: t('Shown only with Alt held or Show tooltips on.'),
        stored: t('Nothing is stored — it only shows the data.'),
        setting: "fe.ux.ganttTipGate",
    }),
    'chart.gantt.empty': (v = {}, ctx = {}) => ({
        title: t('No movements'),
        what: t('Nothing to show for the current filters.'),
        how: t('Change chips or the period.'),
        stored: t('Nothing is stored — it only shows the data.'),
    }),
}

export default charts
